export const productcards = [{
    "title": "AT1700/AT1600",
    "subtitle": "CARDSUBTITLES.RFSWITCH",
    "link": "/products/at1700m",
    "imgsrc": "./assets/images/Products/AT1700M_01.webp",
    "tag": "",
    "text1": "PRODUCTS.AT17001600.MAINTEXT",
    "eol": "0",
    "keyword": "showall current CATV, HFC, RF Switch Multiplexer, Headend",
    "Meta Description": "The AT1700M/AT1600E series multiplexer is a high performance cost-effective broadband RF switching solution.",
    "UL Logo removed?": "yes",
    "finderfilter": "catv rackmount show"
  },
  {
    "title": "AT2500-3G",
    "subtitle": "CARDSUBTITLES.3GHZASA",
    "link": "/products/at2500-3g",
    "imgsrc": "./assets/images/Products/AT2500-3G_01.webp",
    "tag": "DOCSIS 3.X/4.0",
    "text1": "AT2500-3G is the industry’s most complete 3 GHz advanced spectrum analyzer and multi-standards test solution. Incorporating a high-resolution color touch-screen, the AT2500-3G features 3 GHz spectrum analysis, D3.1 OFDM Analysis, digital channel, VeCheck, MPEG analysis and Ethernet test capabilities.  Comprehensive SLM measurements include Single Channel, Headend Check, and FCC Digital POP tests.",
    "eol": "0",
    "keyword": "showall current CATV, HFC, Meter, Network, Maintenance, Headend, Spectrum Analyzer, DOCSIS 3.1, DOCSIS 4.0, Extended Spectrum, 1.8 GHz, 3 GHz, Satellite, Coax, VeCheck, Subcarrier Scan, FCC POP, MPEG, Ethernet, Return Path, Forward Path, Analog, ISDB-T",
    "Meta Description": "The AT2500-3G is the industry’s most complete 3 GHz advanced spectrum analyzer and multi-standards test solution. Incorporating a high-resolution color touch-screen, the AT2500-3G features 3 GHz spectrum analysis, digital channel, VeCheck, MPEG analysis and Ethernet test capabilities. Comprehensive SLM measurements include Single Channel, Fast Full Band and real-time plant level scan, Tilt, Headend Check, and FCC Digital POP tests.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable catv show"
  },
  {
    "title": "CaLan 3010H+",
    "subtitle": "CARDSUBTITLES.DOCSIS31",
    "link": "/products/calan3010hplus",
    "imgsrc": "./assets/images/Products/CaLan3010Hplus_01.webp",
    "tag": "DOCSIS 3.X/4.0",
    "text1": "PRODUCTS.CALAN3010H.MAINTEXT",
    "eol": "0",
    "keyword": "showall current CATV, HFC, Sweep, Sweep System, DOCSIS 3.1, DOCSIS 4.0, Network, 1.8 GHz, Extended Spectrum, VeSion",
    "Meta Description": "The CaLan 3010H+ Sweep System is designed for prequalification, installation, and maintenance of DOCSIS 3.1 and 4.0 networks. The unit consists of a high performance, 1.8 GHz Transmitter and a low noise, 204 MHz Receiver, capable of sweeping the entire Forward and Return path respectively.",
    "UL Logo removed?": "yes",
    "finderfilter": "rackmount catv show"
  },
  {
    "title": "CX41/CX42",
    "subtitle": "CARDSUBTITLES.OUTTDRDMM",
    "link": "/products/cx41-cx42",
    "imgsrc": "./assets/images/Products/CX41_42_01.webp",
    "tag": "",
    "text1": "PRODUCTS.CX4142.MAINTEXT",
    "eol": "0",
    "keyword": "showall current CATV outside plant tdr dmm, time-of-flight (Delay), GNSS antenna feed installation",
    "Meta Description": "The CX41 is a small, ultra-portable, and budget-friendly Time Domain Reflectometer (TDR), ideal for Outside Plant (OSP), and Hybrid Fiber Coax (HFC) network installation and maintenance. Its accurate time-of-flight (Delay) measurement mode makes it a must-have tool for GNSS antenna feed installation and 1PPS precision timing distribution, among other applications. The CX42 is a budget friendly and ultra portable telecom grade Digital Multimeter suitable for the Outside Plant.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable catv show"
  },
  {
    "title": "CX180F",
    "subtitle": "CARDSUBTITLES.CATVFORWARD",
    "link": "/products/cx180f",
    "imgsrc": "./assets/images/Products/CX180F_01.webp",
    "tag": "VeSion",
    "text1": "PRODUCTS.CX180F.MAINTEXT",
    "eol": "0",
    "keyword": "showall current CATV, HFC, Monitoring System, Monitoring Probe, Forward Path, Downstream, VeSion, QAM, Troubleshooting, Proactive Maintenance, Alarm, Coax",
    "Meta Description": "The CX180F Probe is part of the VeSion® Forward monitoring system. Equipped with multiple test engines, the CX180F’s key signal parameters including signal level, BER, MER, and Constellation are scanned continuously and non-intrusively. Advanced spectrum analysis across the entire operating frequency band, detects ingress which can lead to signal impairment and/or failure.",
    "UL Logo removed?": "yes",
    "finderfilter": "rackmount catv show"
  },
  {
    "title": "CX180R+",
    "subtitle": "Return Path Monitoring System",
    "link": "/products/cx180r-plus",
    "imgsrc": "./assets/images/Products/CX180R+_01.webp",
    "tag": "VeSion",
    "text1": "PRODUCTS.CX180RPLUS.MAINTEXT",
    "eol": "0",
    "keyword": "showall current CATV, HFC, Monitoring System, Monitoring Probe, Return Path, Upstream, VeSion, Troubleshooting, Node Health, Proactive Maintenance, Alarm, Coax, VeNode",
    "Meta Description": "The VeSion® Return system monitors the return path for noise, UCD and ingress that interfere with DOCSIS communications. With DOCSIS 3.0/3.1 deployments, higher order upstream QAM modulation and channel bonding are more vulnerable to ingress and should be monitored continuously to ensure peak performance.",
    "UL Logo removed?": "yes",
    "finderfilter": "rackmount catv show"
  },
  {
    "title": "CX280X",
    "subtitle": "CARDSUBTITLES.CATVRF",
    "link": "/products/cx280x",
    "imgsrc": "./assets/images/Products/CX280X_01.webp",
    "tag": "VeSion",
    "text1": "PRODUCTS.CX280X.MAINTEXT",
    "eol": "0",
    "keyword": "showall current CATV, HFC, Monitoring System, Monitoring Probe, Forward Path, DOCSIS 3.1, OFDM, MPEG, 1.8 GHz, Extended Spectrum, Return Path, Downstream, Upstream, VeSion, QAM, ISDB-T, Troubleshooting, Proactive Maintenance, PNM, Node, Node Health, Alarm, Coax",
    "Meta Description": "The CX280X features all-in-one RF Monitoring with QAM, DOCSIS 3.1, ISDB-T, and Fast MPEG monitoring and analysis.",
    "UL Logo removed?": "yes",
    "finderfilter": "rackmount catv show"
  },
  {
    "title": "CX310",
    "subtitle": "CARDSUBTITLES.DOCSIS31INSTALL",
    "link": "/products/docsis-31-installation-tool-cx310",
    "imgsrc": "./assets/images/Products/CX310_01.webp",
    "tag": "DOCSIS 3.X",
    "text1": "The CX310 is equipped with a true DOCSIS 3.1 / 32x8 Cable Modem supporting OFDM measurements as well as VeTest throughput capabilities. Comprehensive SLM features include Single Channel, VeCheck Full Band Scan, Tilt and Ingress.  These key capabilities are the basis of the Home Installation Process (HIP) Auto test, enabling Home Certification conformance testing.",
    "eol": "0",
    "keyword": "showall current CATV, HFC, Meter, Installer, Fulfillment, Forward Path, DOCSIS 3.1, OFDM, Home Certification, HIP, Drop Certification, Low Cost, Cheap, Budget, Lightweight, Portable, Fast, Coax, Contractor, VeCheck, Subcarrier Scan, OFDMA, High-Split, Mid-Split pressrelease",
    "Meta Description": "Equipped with a DOCSIS 3.1 cable modem supporting true OFDM analysis and V-TEST throughput measurements, the CX310 offers unrivaled price and\r\nperformance in a lightweight, ultra-portable form factor. Key features include VeCheck Full Band Scan, OFDM Subcarrier Scans and HIP Home Certification.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable catv show"
  },
  {
    "title": "CX380C",
    "subtitle": "CARDSUBTITLES.ADVPLANT",
    "link": "/products/cx380c",
    "imgsrc": "./assets/images/Products/CX380C_01.webp",
    "tag": "DOCSIS 3.X/4.0",
    "text1": "The CX380C features fast 1.8 GHz Spectrum Analysis and Sweep, DOCSIS 3.1 OFDM, Full SLM, V-Test Speedtest, OPM and TDR/DMM.",
    "eol": "0",
    "keyword": "showall current CATV, HFC, Meter, Network, OSP, ISP, Maintenance, Headend, DOCSIS 3.1, OFDM, Extended Spectrum, 1.8 GHz, Sweep, CaLan, Ingress, Drop Certification, Coax, VeCheck, Subcarrier Scan, Return Path, Forward Path, OFDMA, High-Split, Mid-Split, DOCSIS 4.0, ISDB-T, ISDB-S, ISDB-S3 pressrelease",
    "Meta Description": "Budget Friendly Advanced Maintenance.  The CX380C features fast 1.8 GHz Spectrum Analysis and Sweep, DOCSIS 3.1 OFDM, Full SLM, V-Test Speedtest, OPM, TDR/DMM, and ISDB-T",
    "UL Logo removed?": "yes",
    "finderfilter": "portable catv show"
  },
  {
    "title": "CX380X",
    "subtitle": "CARDSUBTITLES.SPECBURSTQAM",
    "link": "/products/cx380x",
    "imgsrc": "./assets/images/Products/CX380X_01.webp",
    "tag": "VeSion",
    "text1": "PRODUCTS.CX380X.MAINTEXT",
    "eol": "0",
    "keyword": "showall current CATV, HFC, Monitoring System, Monitoring Probe, Forward Path, Downstream, VeSion, QAM, Troubleshooting, Proactive Maintenance, Alarm, Coax, MPEG, Burst QAM",
    "Meta Description": "In order to take a truly ‘proactive’ vs. ‘reactive’ approach in network monitoring, it is important to first detect the plant issues before it becomes significant enough to impact subscribers; then correlate the identified issue(s) to the physical location(s) of the modems contributing harm to the cable plant. Under the VeSion® system umbrella, VeEX’s CX380X advanced Spectrum Analyzer and Burst Demodulator is an add-on to existing CX180R and CX280X preventive network monitoring systems. Specific triggered alarms associated with Upstream parameters of subscriber’s cable modems, such as high transmit levels, can automatically engage deeper dive measurements of the Upstream signal quality. This helps identify the rogue cable modems in the network that contribute harm to the plant.",
    "UL Logo removed?": "yes",
    "finderfilter": "rackmount catv show"
  },
  {
    "title": "DI-1000",
    "subtitle": "CARDSUBTITLES.FIBINS",
    "link": "/products/di1000",
    "imgsrc": "./assets/images/Products/DI1000_01.webp",
    "tag": "",
    "text1": "PRODUCTS.DI1000.MAINTEXT",
    "eol": "0",
    "keyword": "showall current inspection Data Centers fiber inspection microscope fiber scope, fiberscope, wired fiberscope, optical connector inspection, end face inspection, IEC 61300-3-35, transceiver inspection, terminal inspection MPO inspection, MPT inspection, MPO/MTP inspection fiber optics",
    "Meta Description": "The ergonomically designed DI-1000 is an accessory that can be used with VeEX test sets, Windows PC or Android devices by interfacing with its USB 2.0 interface to view a digital image with upto 0.5 um of detection resolution.  The DI-1000 features an easy to use single-finger manual focus knob and an image freeze/live view button.  A comprehensive list of common fiberoptic connectors tips are available. Dirty or scratched connectors introduce loss, increase ORL and can damage other connectors. End-face contamination is a leading cause of fiber link failures in Telecom, MSOs, data centers, and corporate network environments. By focusing on the contact area, the DI-1000 grades the connector’s health and cleanliness after it is polished or cleaned by applying pass/fail analysis per IEC 61300-3-35 standard.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "DI-1000MPO+",
    "subtitle": "CARDSUBTITLES.FIBINSMTPMPO",
    "link": "/products/di1000mpo-plus",
    "imgsrc": "./assets/images/Products/Digital-Fiber-Microscope-for-Multi-Fiber-Connector-Inspection-DI-1000MPO_01.webp",
    "tag": "",
    "text1": "PRODUCTS.DI1000MPO+.MAINTEXT",
    "eol": "0",
    "keyword": "showall current inspection Data Centers fiber inspection microscope fiber scope, fiberscope, wired fiberscope, optical connector inspection, end face inspection, IEC 61300-3-35, transceiver inspection, terminal inspection MPO inspection, MPT inspection, MPO/MTP inspection fiber optics",
    "Meta Description": "Optimized for inspecting MTP/MPO connectors or single fiber connectors, The DI-1000MPO+ has built-in manual focus knob, freeze/live view button as well as XY positioning knobs providing simple and efficient handheld operation. The DI-1000MPO+ is an accessory that can be used with VeEX test sets or Android devices by interfacing with its USB 2.0 interface to view a digital image with upto 0.5 um of detection resolution.  A comprehensive list of common fiberoptic connectors tips are available. Dirty or scratched connectors introduce loss, increase ORL and can damage other connectors. End-face contamination is a leading cause of fiber link failures in Telecom, MSOs, data centers, and corporate network environments. The DI-1000MPO+ grades the connector’s health and cleanliness after it is polished or cleaned by applying pass/fail analysis per IEC 61300-3-35 standard.",
    "UL Logo removed?": "yes",
    "undefined": "rename DI-1000/DI-1000MPO/DI-3000 Series Adapter Tip guide on product page",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "DI-3000",
    "subtitle": "CARDSUBTITLES.FIBINSWIRELESS",
    "link": "/products/di3000",
    "imgsrc": "./assets/images/Products/DI-3000_01.webp",
    "tag": "",
    "text1": "PRODUCTS.DI3000.MAINTEXT",
    "eol": "0",
    "keyword": "showall current fiber inspection microscope fiber scope, fiberscope, Wi-Fi fiber scope, autofocus, optical connector inspection, end face inspection, IEC 61300-3-35, transceiver inspection,  terminal inspection, MPO inspection MPT inspection, MPO/MPT inspection fiber optics",
    "Meta Description": "The  DI-3000 is an accessory with built-in Wi-Fi or wired USB 2.0 operation that can be used with VeEX test sets, Windows PC or Mobile devices to view a digital image with upto 0.5 um of detection resolution.  The DI-3000 features Wi-Fi or wired connectivity with One-Touch auto-focus or manual focus controls, an image freeze/live view button, Wi-Fi On/Off and LED flashlight.  A comprehensive list of common fiberoptic connectors tips are available. Dirty or scratched connectors introduce loss, increase ORL and can damage other connectors. End-face contamination is a leading cause of fiber link failures in Telecom, MSOs, data centers, and corporate network environments. By focusing on the contact area, the DI-3000 grades the connector’s health and cleanliness after it is polished or cleaned by applying pass/fail analysis per IEC 61300-3-35 standard.  Wi-Fi connectivity enables tether-free operation hibited.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FL150 FaultScout®",
    "subtitle": "Fiber Optic Multimeter",
    "link": "/products/fl150",
    "imgsrc": "./assets/images/Products/FL150_01.webp",
    "tag": "New",
    "text1": "PRODUCTS.FL150.MAINTEXT",
    "eol": "0",
    "keyword": "showall, current, optical multimeter, PON, drop fiber, last mile, ORL, live fiber testing, access fiber, OTDR, dual-PON, in-service testing, Live Fiber testing veexresource",
    "Meta Description": "Compact, rugged optical fiber multimeter for novice and service activation technicians to certify optical links within 30 seconds, with single fiber connection. Press Start and let our smart V-Scout link mapping technology with in-line OPM for single or dual PON 1490/1577 nm signals do all the work for you. Fiber inspection scopes are also available.",
    "UL Logo removed?": "yes",
    "finderfilter": "catv show"
  },
  {
    "title": "Fiberizer®",
    "subtitle": "CARDSUBTITLES.FIBOPTTDM",
    "link": "/products/fiberizer",
    "imgsrc": "./assets/images/Products/fiberizer_webpage_update.webp",
    "tag": "",
    "text1": "Software solutions for remote optical testing and data post-processing for managing test data and generating reports that integrate OTDR, link map, GPS coordinates, OLTS (loss and ORL), connector inspection, and captured images. Available for Window PC, Mobile Apps (Android, iPhone and iPad devices) and Fiberizer Cloud. ",
    "eol": "0",
    "keyword": "showall current Fiber testing, Fiber measurement, Fiberizer, Fiberizer Cloud, Cloud storage, OTDR, Automatic analysis, Optical power testing, PDF reporting, Managing test results",
    "Meta Description": "Fiberizer is a family of different software applications that work exclusively with VeEX fiber optic test and connector inspection products. Each mobile or PC software application is designed to streamline the capture, transfer, saving, and/or reporting of test results performed by compatible VeEX fiber testers, increasing the efficiency of technicians tasked to install, commission, troubleshoot, and/or repair fiber optic networks.",
    "UL Logo removed?": "n/a",
    "finderfilter": "software show"
  },
  {
    "title": "FX10+",
    "subtitle": "CARDSUBTITLES.VISFAULT",
    "link": "/products/fx10-plus",
    "imgsrc": "./assets/images/Products/FX10plus_01.webp",
    "tag": "",
    "text1": "",
    "eol": "0",
    "keyword": "showall current Telco inspection Pen Style Visual Fault Locator fiberoptic, VFL, visual fault locator, light red laser fiber optics",
    "Meta Description": "The FX10+ Visual Fault Locator enables technicians to visually check for signal continuity, excessive light leakage for single strand fibers and trace or verify proper cable routing using red laser technology.",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FX15",
    "subtitle": "CARDSUBTITLES.LIVEFIBIDENT",
    "link": "/products/fx15",
    "imgsrc": "./assets/images/Products/FX15_01.webp",
    "tag": "",
    "text1": "",
    "eol": "0",
    "keyword": "showall current Telco inspection Live Fiber Identifier fiber identifier, fiberID, Tone detection, fiber bending fiber optics",
    "Meta Description": "The FX15 Fiber Identifier allows technicians to locate fibers at remote locations are terminated correctly by confirming signal and correct modulation/tone.  Also used to verify dark fibers in splice trays slated to be re-routed for cutover projects.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FX120 Series",
    "subtitle": "PON Analyzer and Multi-Gig Service Test Set/PON Analyzer",
    "link": "/products/fx120",
    "imgsrc": "./assets/images/Products/FX120L_01.webp",
    "tag": "New",
    "text1": "The Next Generation FX120 is an all-in-one advanced PON analyzer with a native RJ45 port and an SFP+ cage to support Layer 4+ testing. Ideal for service technicians tasked with service activation and resolving complaints, the FX120 monitors activation process by displaying downstream/upstream power levels as well as OLT/ONT IDs and status and TC-Sync. Certify QoE using optional Speed Test and V-PERF to check internet connectivity and speed up to 10 Gbps. Optional end of fiber detection feature allows technicians to check drop cables length before testing. ",
    "eol": "0",
    "keyword": "showall current PON Analyzer, GPON, XG(S)-PON, EPON, 10G-PON, OLT, ONU/ONT-ID, PON-ID, fiber optics,  Speedtest, RJ45, Fault Locator, TOL, ODN, PLOAM, OC decode veexresource test with flow pressrelease wifi wi-fi",
    "Meta Description": "The Next Generation FX120 is an all-in-one advanced PON analyzer with a native RJ45 port and an SFP+ cage to support Layer 4+ testing. Ideal for service technicians tasked with service activation and resolving complaints, the FX120 monitors activation process by displaying downstream/upstream power levels as well as OLT/ONT IDs and status and TC-Sync. Certify QoE using optional Speed Test and V-PERF to check internet connectivity and speed up to 10 Gbps. Optional end of fiber detection feature allows technicians to check drop cables length before testing. ",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FX150+",
    "subtitle": "PON or Point-to-Point Mini OTDR",
    "link": "/products/fx150-plus",
    "imgsrc": "./assets/images/Products/FX150-plus_01.webp",
    "tag": "",
    "text1": "PRODUCTS.FX150+.MAINTEXT",
    "eol": "0",
    "keyword": "showall current Metro Mini OTDR FTTx fiber optics, PON OTDR, OTDR pressrelease",
    "Meta Description": "Standard OTDR or PON optimized OTDR with up to 256,000 data points and 3 cm resolution, the FX150+ mini OTDR offers superior measurement accuracy for installation, maintenance and troubleshooting of FTTx, Mobile FrontHaul/BackHaul and Metro fiber networks. The compact, lightweight test set can be incorporated with power meter, light source, fiber inspection probe and VFL test options which add exceptional versatility to the unit.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FX180X",
    "subtitle": "CWDM OCC",
    "link": "/products/optical-channel-checker-fx180x",
    "imgsrc": "./assets/images/Products/FX180X-OCC_01.webp",
    "tag": "",
    "text1": "PRODUCTS.FX180XCWDM.MAINTEXT",
    "eol": "0",
    "keyword": "showall current Optical Channel Checker, WDM, CWDM, DWDM, fiber optic, singlemode fiber optics, OCC, wavelength, frequency, power measurement",
    "Meta Description": "Compact Channel Checker Verifying CWDM Channels and Power. Simultaneously test all 18 CWDM channels or 97 DWDM channels C14-62 in a single test. This compact, robust tester measures individual channel peak wavelength/frequency and total, composite power. An optional fiberscope is also available to inspect connectors.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FX182",
    "subtitle": "CARDSUBTITLES.XWDMOCC",
    "link": "/products/fx182",
    "imgsrc": "./assets/images/Products/FX182_01.webp",
    "tag": "",
    "text1": "PRODUCTS.FX182.MAINTEXT",
    "eol": "0",
    "keyword": "showall current Optical Channel Checker, WDM, CWDM, DWDM, fiber optic, singlemode fiber optics, OCC, wavelength, frequency, power measurement",
    "Meta Description": "The FX182 is the industry’s first compact Channel Checker to measure both CWDM and DWDM (C&L) band channels in less than 3 seconds. Innovative color-coded display identifies frequency, signal level, pass/fail and marginal channels at a glance*.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FX40",
    "subtitle": "CARDSUBTITLES.OPMOLS",
    "link": "/products/fx40series",
    "imgsrc": "./assets/images/Products/FX40Series_01.webp",
    "tag": "",
    "text1": "PRODUCTS.FX40.MAINTEXT",
    "eol": "0",
    "keyword": "showall current portable handheld broadband power meter fiber optic CATV MSO Telco FTTH PON Optical Power Meter (OPM) Optical Light Source (OLS) fiber optics",
    "Meta Description": "Low cost, palm-sized broadband, optical power meter for singlemode or multimode networks to measure and save absolute (dBm) or relative power (dB) levels. Standard power range (telco) or high power range (CATV or amplified) meters available. Fiberizer® software for Windows® Desktop, Android™, and/or Apple® mobile devices is available to assist in data transfer, record management, and report generation for various VeEX fiber optics testers. View the Fiberizer webpage for more details.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FL41",
    "subtitle": "Optical Fault Locator",
    "link": "/products/fl41",
    "imgsrc": "./assets/images/Products/FL41_01.webp",
    "tag": "New",
    "text1": "PRODUCTS.FL41.MAINTEXT",
    "eol": "0",
    "keyword": "showall current fault locator optical power meter OPM fiber optics drop fiber PON test with flow",
    "Meta Description": "The FL41 is a budget friendly and palm-sized Fault Locator/ Optical Power Meter for measuring fiber spans up to 20 km in length. The FL41f has a built-in filter for in-service fault locating. The FL41 is the perfect tool for service activation technicians who need to measure short fiber links and drop fiber for PON, 5G rollout, FTTx, LAN/WAN, and CATV.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FX41xT",
    "subtitle": "PRODUCTS.FX41XT.SUBTITLE",
    "link": "/products/fx41xt",
    "imgsrc": "./assets/images/Products/FX41xT_01.webp",
    "tag": "New",
    "text1": "PRODUCTS.FX41XT.MAINTEXT",
    "eol": "0",
    "keyword": "showall current portable handheld PON power meter fiber optic 1G 10G singlemode FTTH fiber optics B/GPON, XG(S)-PON, EPON and 10G-EPON ONU/ONT drop fiber downstream selective terminated non-pass through test with flow",
    "Meta Description": "The ultra-portable FX41xT provides fast, simple, and precise measurement of G-PON and XGS-PON downstream signals. Miniature filters ensure each wavelength is measured accurately. It is well suited for installation, service verification, and troubleshooting of co-existent networks, including IEEE based E-PON and 10G-EPON deployments.",
    "UL Logo removed?": "",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FX45/48",
    "subtitle": "CARDSUBTITLES.OPMOLSOLTS",
    "link": "/products/fx45series",
    "imgsrc": "./assets/images/Products/FX45Series_01.webp",
    "tag": "",
    "text1": "PRODUCTS.FX4548.MAINTEXT",
    "eol": "0",
    "keyword": "showall current portable handheld broadband power meter fiber optic CATV MSO construction Telco FTTH PON Optical Power Meter (OPM) Optical Light Source (OLS) Optical Loss Test Set (OLTS) fiber optics",
    "Meta Description": "Low cost, palm-sized broadband, optical power meter for singlemode or multimode networks to measure and save absolute (dBm) or relative power (dB) levels. Standard power range (telco) or high power range (CATV or amplified) meters available. The FX48 features additional pre-calibrated test wavelengths.  Fiberizer® software for Windows® Desktop, Android™, and/or Apple® mobile devices is available to assist in data transfer, record management, and report generation for various VeEX fiber optics testers. View the Fiberizer webpage for more details.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FX81/FX81T",
    "subtitle": "1G/10G/25G PON OPM",
    "link": "/products/fx81",
    "imgsrc": "./assets/images/Products/FX81T_25G_03.webp",
    "tag": "",
    "text1": "PRODUCTS.FX81T25G.MAINTEXT",
    "eol": "0",
    "keyword": "showall current PON power meter fiber optic 10G singlemode FTTH fiber optics FX81T B/GPON, XG(S)-PON, EPON and 10G-EPON ONU/ONT 25G 25G PON 25GS-PON test with flow",
    "Meta Description": "Optical power meter for installation, service activation and troubleshooting of B/GPON, XG(S)-PON, 25G PON, EPON and 10G-EPON fiber networks. Pass-through design to measure multiple downstream and upstream signals simultaneously for ONU/ONT verification or non-pass through/terminated OLT verification.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FX82/82s",
    "subtitle": "CARDSUBTITLES.OPM",
    "link": "/products/optical-power-meter-fx82",
    "imgsrc": "./assets/images/Products/Optical-Power-Meter-FX82_00.webp",
    "tag": "",
    "text1": "PRODUCTS.FX82.MAINTEXT",
    "eol": "0",
    "keyword": "showall current optical power meter, OPM, InGaAs, CATV, MSO, Telco, FTTH, PON, sweep, multi-wavelength, CWDM, OPM c-band, tunable optical light source, sweep generator, optical power meter, sweep receiver, DWDM, automated OLTS, insertion loss, cable route verification, CATV, MSO, Telco, WDM, RAN, 5G, TLS, laser fiber optics",
    "Meta Description": "The FX82 features excellent measurement accuracy over a broad wavelength and wide dynamic range in demanding test environments. The unit is calibrated at all legacy wavelengths while CWDM wavelengths can be added as an option. Automate multi-wave DWDM IL loss measurement and verify cable routes using our new Sweep Loss Test Kit, comprised of FX87s and FX82s meters.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FX83",
    "subtitle": "CARDSUBTITLES.OLS",
    "link": "/products/optical-light-source-fx83",
    "imgsrc": "./assets/images/Products/Optical-Light-Source-FX83_00.webp",
    "tag": "",
    "text1": "PRODUCTS.FX83.MAINTEXT",
    "eol": "0",
    "keyword": "showall current light source singlemode multimode FTTH PON fiber optics",
    "Meta Description": "The FX83 OLS is equipped with high performance lasers offering excellent wavelength and power stability over a broad operating temperature range. Each source features WaveID which can be used with compatible VeEX optical power meters for correct wavelength recognition. The source can be configured with up to four singlemode wavelengths (1310nm, 1490nm, 1550nm, or 1625nm) on a single output port for verifying FTTx/PON telecom, CATV or government/defense fiber network applications. Alternatively, up to four wavelengths (850/1300nm multimode* and 1310/1550nm singlemode) can be configured on two individual ports for testing LAN/WAN access and enterprise/data centers utilizing both multimode* and singlemode fiber types. The multi-wave (loop) function automatically toggles through all wavelengths for faster loss measurements.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FX84",
    "subtitle": "CARDSUBTITLES.OLTSUNI",
    "link": "/products/optical-loss-test-set-fx84",
    "imgsrc": "./assets/images/Products/Optical-Loss-Test-Set-FX84_00.webp",
    "tag": "",
    "text1": "PRODUCTS.FX84.MAINTEXT",
    "eol": "0",
    "keyword": "showall current OLTS singlemode light source multimode CATV MSO construction Telco FTTH PON fiber optics",
    "Meta Description": "The FX84 Optical Loss Test Set (OLTS) combines power meter and light source functions into a single test unit. Individual test ports provide uni-directional loss measurements allowing two technicians on opposite ends of a fiber link to test simultaneously. The auto-loop feature toggles the light source wavelengths, while the remote or local OPM test partner detects the incoming wavelength/s automatically using the WaveID feature.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FX86",
    "subtitle": "CARDSUBTITLES.OLSCWDM",
    "link": "/products/cwdm-quad-laser-source-fx86",
    "imgsrc": "./assets/images/Products/CWDM-Quad-Laser-Source-FX86_01.webp",
    "tag": "",
    "text1": "PRODUCTS.FX86.MAINTEXT",
    "eol": "0",
    "keyword": "showall current CWDM fiber optic light source PON FTTH fiber optics",
    "Meta Description": "The FX86 is a four port laser source used to verify, install and commission CWDM and PON networks. Verify wavelength routing and troubleshoot passive CWDM network elements or verify multiple PON drops with unique tone identifiers. Optimized for Access & Metro CWDM or PON test applications.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FX87/87s",
    "subtitle": "CARDSUBTITLES.TLSDWDM",
    "link": "/products/dwdm-tunable-laser-source-fx87",
    "imgsrc": "./assets/images/Products/DWDM-Tunable-Laser-Source-FX87_01.webp",
    "tag": "",
    "text1": "PRODUCTS.FX87.MAINTEXT",
    "eol": "0",
    "keyword": "showall current DWDM, C-band, fiber optic, tunable light source, 50GHz, 100GHz, Fiber Deep, 5G, sweep generator, TLS, laser, dFB c-band, tunable optical light source, sweep generator, optical power meter, sweep receiver, DWDM, automated OLTS, insertion loss, cable route verification, CATV, MSO, Telco, WDM, RAN, 5G, TLS, laser fiber optics",
    "Meta Description": "The FX87 DWDM TLS can be tuned to any G.694.1 channel on the 50 GHz frequency grid over the C-band spectrum. Test applications include verifying end-end wavelength routing and troubleshooting passive Multiplexer and Demultiplexer network elements. Optimized for Fiber Deep, Metro and Core networks employing DWDM technology. Automate multi-wave DWDM IL loss measurement and verify cable routes using our new Sweep Loss Test Kit, comprised of FX87s and FX82s meters.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "FX92",
    "subtitle": "DWDM Optical Channel Checker",
    "link": "/products/fx92",
    "imgsrc": "./assets/images/Products/FX92_01.webp",
    "tag": "New",
    "text1": "PRODUCTS.FX92.MAINTEXT",
    "eol": "0",
    "keyword": "showall current DWDM, C-band, fiber optic, tunable light source, 50GHz, 100GHz, Fiber Deep, 5G, sweep generator, TLS, laser, dFB c-band, tunable optical light source, sweep generator, optical power meter, sweep receiver, DWDM, automated OLTS, insertion loss, cable route verification, CATV, MSO, Telco, WDM, RAN, 5G, TLS, laser fiber optics, Optical Channel Checker, WDM, CWDM, DWDM, fiber optic, singlemode fiber optics, OCC, wavelength, frequency, power measurement, OSA v90 pressrelease",
    "Meta Description": "The FX92 simplifies verification and maintenance of passive DWDM systems by scanning and automatically reporting all available channels with wavelength or frequency and total power level for every channel. In addition to 4 simple views to check the performance of each channel, an OPM mode is available for single channel drop verification details.",
    "UL Logo removed?": "n/a",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "MPA® Multi-Protocol Analyzer",
    "subtitle": "CARDSUBTITLES.ADVPACKETGEN",
    "link": "/products/mpaseries",
    "imgsrc": "./assets/images/Products/MultiProtocolAnalyzer_01.webp",
    "tag": "",
    "text1": "PRODUCTS.MPA.MAINTEXT",
    "eol": "0",
    "keyword": "showall current mpa mpm r&d r+d design manufacturing automation script scripting python scpi svt development transceiver dli digital lightwave nic",
    "Meta Description": "The MPA® Multi-Protocol Analyzer is an advanced packet optical transport traffic generation and analysis platform specifically designed for the demands of R&D, SVT, and manufacturing testing environments. The MPA provides simultaneous independent multi-port testing from 1G to 400G for Ethernet/IP, OTN & SDH/SONET and Fibre Channel. Advanced and flexible FPGA based test modules provide future proof hardware support for emerging standards. Supports license based test options.",
    "UL Logo removed?": "n/a",
    "finderfilter": "modular rackmount ethernet transport show"
  },
  {
    "title": "MPA-HD®",
    "subtitle": "High Density Test System",
    "link": "/products/mpa-hd",
    "imgsrc": "./assets/images/Products/MPA-HD_01.webp",
    "tag": "New",
    "text1": "PRODUCTS.MPAHD.MAINTEXT",
    "eol": "0",
    "keyword": "showall current mpa mpm r&d r+d design manufacturing automation script scripting python scpi svt development transceiver dli digital lightwave nic pressrelease",
    "Meta Description": "",
    "UL Logo removed?": "n/a",
    "finderfilter": "modular rackmount ethernet transport show"
  },
  {
    "title": "MPM-HD-802",
    "subtitle": "Dual Port 800G QSFP-DD800 Test Module",
    "link": "/products/multi-port-800g-qsfp-dd800-test-module-mpm-hd-802",
    "imgsrc": "./assets/images/Products/MPM-HD-802_01.webp",
    "tag": "New",
    "text1": "PRODUCTS.MPAHD802.MAINTEXT",
    "eol": "0",
    "keyword": "showall current mpa analyzer r&d r+d design manufacturing automation script scripting python scpi svt development transceiver dli digital lightwave nic pressrelease",
    "Meta Description": "Advanced traffic generation and analysis platform specifically designed for the demands of R&D, SVT, and manufacturing testing environments.",
    "UL Logo removed?": "n/a",
    "finderfilter": "modular rackmount ethernet transport show"
  },
  {
    "title": "MPM-HD-822",
    "subtitle": "Dual Port 800G OSFP800 Test Module",
    "link": "/products/dual-port-800g-osfp800-test-module-mpm-hd-822",
    "imgsrc": "./assets/images/Products/MPM-HD-822_01.webp",
    "tag": "New",
    "text1": "PRODUCTS.MPAHD822.MAINTEXT",
    "eol": "0",
    "keyword": "showall current mpa analyzer r&d r+d design manufacturing automation script scripting python scpi svt development transceiver dli digital lightwave nic pressrelease",
    "Meta Description": "The MPA-HD platform is specially designed to address the testing challenges in multi-port R&D, SVT and production environments.",
    "UL Logo removed?": "n/a",
    "finderfilter": "modular rackmount ethernet transport show"
  },
  {
    "title": "MPM-100AR",
    "subtitle": "CARDSUBTITLES.100GMULTI",
    "link": "/products/100g-multi-protocol-module",
    "imgsrc": "./assets/images/Products/200-100G-Multi-Protocol-Module_02.png",
    "tag": "",
    "text1": "PRODUCTS.MPM100AR.MAINTEXT",
    "eol": "0",
    "keyword": "showall current mpa analyzer r&d r+d design manufacturing automation script scripting python scpi svt development transceiver dli digital lightwave nic",
    "Meta Description": "The MPM-100AR Multi-Protocol Module is specifically designed to meet the test and measurement challenges of developers and early adopters of next generation Ethernet/IP, Fibre Channel, OTN & SONET/SDH ASICs, optics, transport/switching modules, and service delivery.",
    "UL Logo removed?": "yes",
    "finderfilter": "modular rackmount ethernet transport show"
  },
  {
    "title": "MPM-400AR",
    "subtitle": "CARDSUBTITLES.400GEQSFP",
    "link": "/products/dual-port-400ge-qsfp-dd-pam4-test-module-mpm-400ar",
    "imgsrc": "./assets/images/Products/Dual-Port-400GE-QSFP-DD-PAM4-Test-Module-MPM-400AR_02.webp",
    "tag": "",
    "text1": "PRODUCTS.MPM400AR.MAINTEXT",
    "eol": "0",
    "keyword": "showall current mpa analyzer 400GE QSFP-DD PAM4 800G 400G 200G 100G Monitor Generator automation script DCO DCI data center transceiver testing AOC DAC PAM4 400G 400GE 400ZR ZR+ OpenZR OpenZR+ OpenROADM DCO DAC Fanout Coherent DCI Datacenter Data center r&d r+d design manufacturing automation script scripting python scpi svt development transceiver dli digital lightwave nic",
    "Meta Description": "This advanced module provides up to 800G of throughput to address the high capacity testing demands of the next generation PAM4 Ethernet/transport market. Supporting 2x simultaneous and independent 400G QSFP-DD ports along with 2x QSFP56 and SFP56 ports the MPM-400AR module delivers both convenient and flexible testing capabilities for a wide range of optical transceivers, port and data rates all in the same module.",
    "undefined": "missing spec",
    "finderfilter": "modular rackmount ethernet transport show"
  },
  {
    "title": "MPM-400DCO",
    "subtitle": "PRODUCTS.MPM400DCO.SUBTITLE",
    "link": "/products/400g-cfp2-dco-qsfp-dd-mpm400dco",
    "imgsrc": "./assets/images/Products/MPM-400DCO_02.webp",
    "tag": "",
    "text1": "PRODUCTS.MPM400DCO.MAINTEXT",
    "eol": "0",
    "keyword": "showall current mpa analyzer 400G CFP2-DCO & QSFP-DD 400G 400GE 400ZR ZR+ OpenZR OpenZR+ OpenROADM DCO DAC Fanout Coherent DCI Datacenter Data center r&d r+d design manufacturing automation script scripting python scpi svt development transceiver dli digital lightwave nic",
    "Meta Description": "Advanced test solution for R&D, SVT, and production verification of high performance pluggable coherent CFP2-DCO and QSFP-DD transceivers and applications.",
    "undefined": "missing spec",
    "finderfilter": "modular rackmount ethernet transport show"
  },
  {
    "title": "MPM-400G",
    "subtitle": "CARDSUBTITLES.400GMULTI",
    "link": "/products/400g-multi-protocol-module",
    "imgsrc": "./assets/images/Products/400G-Multi-Protocol-Module_02.webp",
    "tag": "",
    "text1": "PRODUCTS.MPM400G.MAINTEXT",
    "eol": "0",
    "keyword": "showall current mpa analyzer 800G 400G 200G 100G Monitor Generator automation script DCO DCI data center transceiver testing AOC DAC PAM4 400G 400GE 400ZR ZR+ OpenZR OpenZR+ OpenROADM DCO DAC Fanout Coherent DCI Datacenter Data center r&d r+d design manufacturing automation script scripting python scpi svt development transceiver dli digital lightwave nic",
    "Meta Description": "The MPM-400G Multi-Protocol Module is specifically designed to meet the test and measurement challenges of developers and early adopters of 400G ASICs, CFP8 optics, transport/switching modules, and service delivery.",
    "UL Logo removed?": "yes",
    "finderfilter": "modular rackmount ethernet transport show"
  },
  {
    "title": "MPM-600G",
    "subtitle": "CARDSUBTITLES.100GQSFP28MULTI",
    "link": "/products/6x-port-100g-qsfp28-multi-protocol-module",
    "imgsrc": "./assets/images/Products/6x-Port-100G-QSFP28-Multi-Protocol-Module_02.webp",
    "tag": "",
    "text1": "PRODUCTS.MPM600G.MAINTEXT",
    "eol": "0",
    "keyword": "showall current mpa analyzer 100G QSFP28 Multi-Protocol 800G 400G 200G 100G Monitor Generator automation script DCO DCI data center transceiver testing AOC DAC PAM4 r&d r+d design manufacturing automation script scripting python scpi svt development transceiver dli digital lightwave nic",
    "Meta Description": "The MPM-600G Multi-Protocol Module is an advanced multi-port QSFP28 test module for high density 40/100G and next-generation OTUCn & FlexE applications.",
    "UL Logo removed?": "yes",
    "finderfilter": "modular rackmount ethernet transport show"
  },
  {
    "title": "MTTplus Family",
    "subtitle": "CARDSUBTITLES.MODTESTPLAT",
    "link": "/products/mttplusseries",
    "imgsrc": "./assets/images/Products/MTTplus_01.webp",
    "tag": "VeExpress",
    "text1": "PRODUCTS.MTTPLUS.MAINTEXT",
    "eol": "0",
    "keyword": "showall current mtt-plus mtt plus modular test platform chassis instrument meter test set testset tester GNSS GPS veexresource",
    "Meta Description": "The MTTplus platform builds on the legacy of the legendary MTT®, providing a compact, powerful and cost-effective modular test toolkit for today’s wide range of evolving test needs. The compact MTTplus Modular Test Platform addresses the challenges of communication service providers to increase efficiency and productivity. The flexible test platform lowers operational and capital expenditures associated with handling multiple technologies required to address today’s Access, Business, Carrier Ethernet, Transport and Core services.",
    "UL Logo removed?": "n/a",
    "finderfilter": "portable modular fiber ethernet transport dsl wi-fi wifi show"
  },
  {
    "title": "MTTplus-260",
    "subtitle": "CARDSUBTITLES.SHDSLTESTMOD",
    "link": "/products/mttplusshdsltestmoduleoption",
    "imgsrc": "./assets/images/Products/MTTplusSHDSLTestModuleOption_01.webp",
    "tag": "",
    "text1": "PRODUCTS.MTTPLUS260.MAINTEXT",
    "eol": "0",
    "keyword": "showall current Telco, SHDSL, SHDSL.bis, EFM, Business Class DSL, Symmetrical, Lantiq mtt-plus mtt plus 260 mtt-260",
    "Meta Description": "MTT® Plus SHDSL Test Module provides CPE installation, CO emulation pre-qualification, and IP/ATM services testing capabilities for service installation and verification. The module is based on the industry leading Lantiq SOCRATES chipset, offering best-in-class SHDSL performance and interoperability. SHDSL is ideal for business class services, enterprise networks, and industrial communications that must rely on legacy copper based networks where fiber remains cost prohibitive. Utilizing SHDSL’s multiple pair bonding application enables robust data transmission over long copper lines.",
    "UL Logo removed?": "yes",
    "finderfilter": "show"
  },
  {
    "title": "MTTplus-340",
    "subtitle": "CARDSUBTITLES.MULTISERVTESTMOD",
    "link": "/products/mttplus-340",
    "imgsrc": "./assets/images/Products/MTTplus340_01.webp",
    "tag": "",
    "text1": "PRODUCTS.MTTPLUS340.MAINTEXT",
    "eol": "0",
    "keyword": "showall current mtt-plus mtt plus mtt-340 telco ethernet internet QoS QoE SLA BER BERT throughput RFC 2544 RFC6349 V_PERF iperf v-perf speed speedtest Ookla Speedtest 16GFC 16G 10G 5G 2.5G 1G sdh sonet PDH DSn T1 T3 OC STS E1 fibre channel datacom ieee C37.94 CPRI OBSAI SyncE Sync jitter wander one-way dealy OWD packet capture loopback v-sam vsam sam y.1564 1564 sla qos qoe speedtest speed v-test vtest v-perf vperf iperf iperf3 rfc6349 6349",
    "Meta Description": "The MTTplus-340 test module offers advanced test solutions for Access, Metro and Carrier Ethernet, supporting OTN, SONET/SDH, PDH/DSn, Fibre Channel, CPRI, C37.94 and Synchronization. This compact and flexible test platform helps service providers increase efficiency and productivity. It lowers OpEx and CapEx associated with handling multiple technologies required to address today’s Access, Business, Carrier Ethernet, Transport and Core services.",
    "undefined": "Missing from MTTplus platform page; wrong title",
    "finderfilter": "portable modular ethernet transport show"
  },
  {
    "title": "MTTplus-410+",
    "subtitle": "CARDSUBTITLES.OTDRMOD",
    "link": "/products/mttplus-410-plus-fiber-optics-test-module",
    "imgsrc": "./assets/images/Products/MTTplus-410-plus-Fiber-Optics-Test-Module_01.webp",
    "tag": "",
    "text1": "PRODUCTS.MTTPLUS410+.MAINTEXT",
    "eol": "0",
    "keyword": "showall current OTDR, PON, fiber optic, singlemode, multimode mtt-plus mtt plus mtt-410 fiber optics",
    "Meta Description": "The MTTplus-410+ Fiber Optics test module for the VeEX® MTTplus platform now has up to 500,000 data points with 3 cm resolution. The MTTplus-410+ supports a full range of test functions including OTDR, OPM, Light Source and VFL. GPS coordinates and images can be embedded into the OTDR sor files and PDF test report provided the MTTplus platform is configured with GPS and Camera options. Fiberizer® software for Windows® Desktop, Android™, and/or Apple® mobile devices is available to assist in data transfer, record management, and report generation for various VeEX fiber optics testers. View the Fiberizer webpage for more details.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "MTTplus-522",
    "subtitle": "CARDSUBTITLES.OSPTESTMOD",
    "link": "/products/mttplus-522-osp-plus-module",
    "imgsrc": "./assets/images/Products/MTTplus-522-OSP-plus-Module_01.webp",
    "tag": "",
    "text1": "PRODUCTS.MTTPLUS522.MAINTEXT",
    "eol": "0",
    "keyword": "showall current Telco, OSP, Copper, FTTN, DSL, VDSL2, DMM, TDR, RFL, G.fast, Balance, mtt-plus, mtt plus mtt-522",
    "Meta Description": "The MTTplus-522 Outside Plant (OSP)+ Expert Module combines key copper verification features with DSL/G.fast modem emulation. It is designed for Service Providers deploying broadband services over a DSL or G.fast access network.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable modular dsl show"
  },
  {
    "title": "MTTplus-523",
    "subtitle": "CARDSUBTITLES.GFASTDSLTEST",
    "link": "/products/mttplus-523-g-fast-dsl-module",
    "imgsrc": "./assets/images/Products/MTTplus-523-G-fast-DSL-Module_01.webp",
    "tag": "",
    "text1": "PRODUCTS.MTTPLUS523.MAINTEXT",
    "eol": "0",
    "keyword": "showall current Telco, OSP, Copper, FTTN, DSL, VDSL2, G.fast, ADSL, mtt-plus, mtt plus mtt-523",
    "Meta Description": "The MTTplus-523 Module addresses key test requirements for IP based broadband services deployed over a G.fast or DSL Access network.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable modular dsl show"
  },
  {
    "title": "MTX150",
    "subtitle": "CARDSUBTITLES.MULTISERVTEST",
    "link": "/products/mtx150",
    "imgsrc": "./assets/images/Products/MTX150_01.webp",
    "tag": "",
    "text1": "PRODUCTS.MTX150.MAINTEXT",
    "eol": "0",
    "keyword": "showall current telco ethernet internet QoS QoE SLA BER BERT throughput RFC 2544 6349 iperf v-perf speed speedtest 10G 1G sdh sonet PDH DSn T1 T3 OC STS E1 fibre channel datacom ieee C37.94 CPRI OBSAI SyncE Sync jitter wander v-sam vsam sam y.1564 1564 sla qos qoe speedtest speed v-test vtest v-perf vperf iperf iperf3 rfc6349 6349",
    "Meta Description": "The MTX150 is a fully integrated and self-contained 10G multi-service test solution for, Ethernet, SyncE SDH, SONET, PDH, DSn, , Mobile Backhaul, and Fibre Channel (SAN). This all-in-one, rugged and ultra-portable field handheld test set can be configured with interfaces and technologies required by field technicians to install, verify, maintain and troubleshoot Transport, Metro, Access communication links and services up to 10 Gbps, including legacy applications.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable ethernet transport show"
  },
  {
    "title": "MTX150x",
    "subtitle": "CARDSUBTITLES.ETHTEST",
    "link": "/products/mtx150x",
    "imgsrc": "./assets/images/Products/MTX150x_01.webp",
    "tag": "",
    "text1": "PRODUCTS.MTX150X.MAINTEXT",
    "eol": "0",
    "keyword": "showall current telco ethernet internet fibre channel SyncE QoS QoE SLA BER BERT throughput RFC 2544 V-PERF iperf perf speed speedtest 10G 1G 2.5G 5G Multi-Gig Multi-Gigabit RFC6349 Ookla Speedtest ITU-T Y.1564 V-SAM veexresource test with flow v-sam vsam sam y.1564 1564 sla qos qoe speedtest speed v-test vtest v-perf vperf iperf iperf3 rfc6349 6349 wifi wi-fi",
    "Meta Description": "The MTX150x is a fully-integrated and self-contained Ethernet services test solution for Layer 1-to-4+ applications and Fibre Channel (SAN). This rugged and ultra-portable field hand-held test set can be configured with interfaces and technologies required by field technicians to install, verify, maintain and troubleshoot Metro Ethernet links, Business services, Internet Access and other packet-base services up to 10 Gbps. Its native support for 2.5G/5G/10GBASE-T reduces cost of ownership.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable ethernet transport show"
  },
  {
    "title": "MTX150x Lite",
    "subtitle": "Multi-Gigabit Internet Service Analyzer",
    "link": "/products/mtx150x-lite",
    "imgsrc": "./assets/images/Products/MTX150x-Lite_01.webp",
    "tag": "",
    "text1": "PRODUCTS.MTX150XLITE.MAINTEXT",
    "eol": "0",
    "keyword": "showall current telco ethernet internet fibre channel SyncE QoS QoE SLA BER BERT throughput RFC 2544 iperf perf speed speedtest 10G 1G 2.5G 5G Multi-Gig Multi-Gigabit PoE Cable Check RFC6349 V-PERF Ookla Speedtest veexresource test with flow v-sam vsam sam y.1564 1564 sla qos qoe speedtest speed v-test vtest v-perf vperf iperf iperf3 rfc6349 6349",
    "Meta Description": "The MTX150x Lite is an optimized Quality of Experience (QoE) test solution (Layer 4+ applications) for multi-Gigabit services from 10 Mbps to 10 Gbps on copper and fiber interfaces. This rugged, self-contained, and ultra-portable hand-held test set helps field technicians install, verify, maintain, and troubleshoot high-speed Residential and Business services, Internet Access and other packet-base services up to 10 Gbps. Its native support for 2.5G/5G/10GBASE-T reduces cost of ownership.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable ethernet transport show"
  },
  {
    "title": "NoApp®",
    "subtitle": "QR Enabled Software",
    "link": "/noapp",
    "imgsrc": "./assets/images/noapp/Picture2.webp",
    "tag": "",
    "text1": "SOFTWARE.NOAPP.P1",
    "eol": "0",
    "keyword": "showall current qr qrcode qr code scan app fx fiber ethernet no app pdf json rserver r-server cloud result results company project email sms text  speed test speedtest fault locator",
    "Meta Description": "VeEX's NoApp® (US Patent 12,190,199) uses NFC and  QR code technologies to process and consolidate test results data, from small meters to more advanced test sets, efficiently as part of our vision to streamline workflow and reporting. ",
    "UL Logo removed?": "yes",
    "finderfilter": ""
  },
  {
    "title": "OPX-BOXe",
    "subtitle": "CARDSUBTITLES.MINIOTDR",
    "link": "/products/opxboxe",
    "imgsrc": "./assets/images/Products/OPXBOXe_01.webp",
    "tag": "",
    "text1": "PRODUCTS.OPXBOXE.MAINTEXT",
    "eol": "0",
    "keyword": "showall current OTDR, PON fiber optic, singlemode, multimode fiber optics",
    "Meta Description": "The OPX-BOXe is an ultra-compact, OTDR designed to operate remotely using Fiberizer® software. The unit can be controlled via Wi-Fi, Bluetooth or USB from Windows, iOS, Linux or Android devices. Fiberizer® software for Windows® Desktop, Android™, and/or Apple® mobile devices is available to assist in data transfer, record management, and report generation for various VeEX fiber optics testers.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "OTT",
    "subtitle": "Optical Test Tool for Fiber Construction and Maintenance",
    "link": "/products/ott",
    "imgsrc": "./assets/images/Products/OTT_01.webp",
    "tag": "New",
    "text1": "PRODUCTS.OTT.MAINTEXT",
    "eol": "0",
    "keyword": "showall current OTT, Optical Test Tool, Remote Test Tool, Construction, Verification, Switch, ports, power meter, splitter cabinets, optical switch, remote switch, maintenance",
    "Meta Description": "The OTT is an innovative test solution that enhances workflow efficiency for field operations at fiber distribution cabinets. Field technicians can remotely switch between up to 16 or 32 distribution fibers to the desired Fiber Serving Terminal (FST) using simple text commands. This facilitates accurate power measurements on individual ports, eliminating time-consuming trips back to the fiber distribution cabinet, thereby boosting productivity and reducing operational costs across various testing scenarios.",
    "finderfilter": "portable show"
  },
  {
    "title": "OXA-4000",
    "subtitle": "CARDSUBTITLES.FIBOPTACCESSSWITCH",
    "link": "/products/optical-test-access-unit-oxa-4000",
    "imgsrc": "./assets/images/Products/Optical-Test-Access-Unit-OXA-4000_01.webp",
    "tag": "VeSion",
    "text1": "PRODUCTS.OXA4000.MAINTEXT",
    "eol": "0",
    "keyword": "showall current switch, fiber, singlemode, RFTS, Remote Fiber Monitoring, FWDM fiber optics",
    "Meta Description": "VeEX® OXA-4000 series optical test access unit is used with the RTU-4000 fiber probe to support network monitoring of dark or in-service fiber networks. The OXA-4000 provides reliable, fast, and repeatable performance and is powered and controlled via RTU-4000.",
    "UL Logo removed?": "yes",
    "finderfilter": "rackmount fiber show"
  },
  {
    "title": "OXC-4000",
    "subtitle": "PRODUCTS.OXC4000.SUBTITLE",
    "link": "/products/oxc4000",
    "imgsrc": "./assets/images/Products/OXC-4000_01.webp",
    "tag": "VeSion | New",
    "text1": "PRODUCTS.OXC4000.MAINTEXT",
    "eol": "0",
    "keyword": "showall current switch, fiber, singlemode, RFTS, Remote Fiber Monitoring, FWDM fiber optics",
    "Meta Description": "The OXC-4000 series switches are designed specifically for testing fiber dense networks and can be controlled directly by the RTU/RFTS test probe or remotely via VeEX's VeSion server. It can be easily cascaded to allow a single RTU to monitor up to 4608 fiber ports. The OXC-4000 can be located with the RTU or even off-site at nodes with multiple fiber branching and controlled over ethernet.",
    "UL Logo removed?": "yes",
    "finderfilter": "rackmount fiber show"
  },
  {
    "title": "PX90",
    "subtitle": "PON Service Installation Meter",
    "link": "/products/px90",
    "imgsrc": "./assets/images/Products/PX90_01.webp",
    "tag": "New",
    "text1": "PRODUCTS.PX90.MAINTEXT1",
    "eol": "0",
    "keyword": "showall current portable handheld PON opm power meter fiber optic 1G  singlemode smf FTTH fiber optics GPON, XG(S)-PON, xgs-pon g-pon opm PONT pon-t coexistence cex odn ont olt selective power meter fiber optics Speedtest, speed test iperf iperf3 v-test RJ45 wi-fi wifi wlan lan 10/100/1000base-t ethernet 1GigE 1ge qoe qos 802.11 /a /ax /n v90 pressrelease epon e-pon 10gpon 10gepon ookla v-perf internet",
    "Meta Description": "Efficient, simple, precise and cost-effective step-by-step validation for GPON and XGS-PON installations. From selective optical power measurements (OPM) to Internet access speed test validation over LAN and Wi-Fi, provide field technicians with the tools required to quickly validate service speeds and quality of experience (QoE) for residential subscribers. The PX90 test set is well suited for installation, service verification, and troubleshooting of co-existent PON networks, including IEEE based G-PON and XGS-PON deployments.",
    "UL Logo removed?": "n/a",
    "finderfilter": "portable fiber show"
  },
  {
    "title": "RFTS-400",
    "subtitle": "CARDSUBTITLES.REMOTEFIBTEST",
    "link": "/products/rfts-400",
    "imgsrc": "./assets/images/Products/RFTS-400_01.webp",
    "tag": "VeSion | New",
    "text1": "PRODUCTS.RFTS400.MAINTEXT",
    "eol": "0",
    "keyword": "showall current fiber, singlemode, RFTS Remote Fiber Monitoring fiber optics, Proactive monitoring, PON monitoring,PON Construction,fiber integrity,KPI,MTTR,MTTF,MTTD pressrelease otdr",
    "Meta Description": "The RFTS-400 modular platform design incorporates Optical Control Module (OCM) and Optical Switching Modules (OSM) that support fiber monitoring expansion from 8 to 108 ports in the 1U rack. A fully expanded system can support up to 4608 monitoring ports. The RFTS monitors optical fiber infrastructures in Core, Metro, Access and FTTx/PON networks with or without traffic, improving workflow and reducing Mean Time to Repair (MTTR). The RFTS can be operated in standalone mode or as part of a centralized Monitoring System.",
    "UL Logo removed?": "yes",
    "finderfilter": "catv rackmount show"
  },
  {
    "title": "RTU-300+",
    "subtitle": "PRODUCTS.RTU300PLUS.SUBTITLE",
    "link": "/products/rtu-300plus",
    "imgsrc": "./assets/images/Products/RTU-300+_01.webp",
    "tag": "New",
    "text1": "PRODUCTS.RTU300PLUS.MAINTEXT",
    "eol": "0",
    "keyword": "showall current rtu300+ rtu 300+ rtu300p rtu300plus rtu-300p rtu-300plus",
    "Meta Description": "The RTU-300+ platform is a rack-mounted centralized test solution specially designed for service turn-up and maintenance test applications. The RTU-300+ can be remotely accessed via a web browser or VNC when configured for standalone operation, or it can be operated and integrated into the VeSion® cloud-based system. Features include Ethernet test applications, including high performance stateful TCP suites, like RFC6349, required for repeatable and reliable testing of broadband or IP access services. When the RTU-300+ platform is configured for standalone operation additional features are supported like OTN, SDH/SONET, Fibre Channel, and CPRI.",
    "UL Logo removed?": "yes",
    "finderfilter": "ethernet modular show"
  },
  {
    "title": "RTU-340",
    "subtitle": "CARDSUBTITLES.DUAL10GTEST",
    "link": "/products/rtu-340",
    "imgsrc": "./assets/images/Products/RTU-340_01.webp",
    "tag": "New",
    "text1": "PRODUCTS.RTU340.MAINTEXT",
    "eol": "0",
    "keyword": "showall current rtu300+ rtu 300+ rtu300p rtu300plus rtu-300p rtu-300plus v-sam vsam sam y.1564 1564 sla qos qoe speedtest speed v-test vtest v-perf vperf iperf iperf3 rfc6349 6349",
    "Meta Description": "The RTU-340 hardware option for the RTU-300+ standalone platform offers a full-featured centralized test solution for Ethernet, OTN, SONET/SDH, PDH/DSn, Fibre Channel and CPRI/OBSAI. This factory-installed hardware option allows flexibility to fit any application, such as the addition of a second RTU-340 or 100G (RTU-600x) to be installed concurrently in the same test platform.",
    "UL Logo removed?": "yes",
    "finderfilter": "ethernet modular show"
  },
  {
    "title": "RTU-600x",
    "subtitle": "CARDSUBTITLES.ADV100GTEST",
    "link": "/products/rtu-600x",
    "imgsrc": "./assets/images/Products/RTU-600x_01.webp",
    "tag": "New",
    "text1": "PRODUCTS.RTU600X.MAINTEXT",
    "eol": "0",
    "keyword": "showall current ethernet cloud rtu-320 rtu-600x rtu 320 600x ethernet internet QoS QoE SLA BER BERT throughput RFC 2544 6349 iperf v-perf speed speedtest 10G 1G  cloud vision rtu-300 rtu-300+ rtu 300 rtu300+ rtu 300+ rtu300p rtu300plus rtu-300p rtu-300plus v-sam vsam sam y.1564 1564 sla qos qoe speedtest speed v-test vtest v-perf vperf iperf iperf3 rfc6349 6349",
    "Meta Description": "Available in stand-alone or combined with other modules, the RTU-600x hardware option for the RTU-300 standalone platform offers a full-featured centralized test solution for Ethernet links and services testing — from 10 Mbps and 100 Gbps. This low-cost factory-installed hardware option allow flexibility to fit any modern Core, Metro, NOC, PoP, mobile backhaul, and datacenter applications.",
    "UL Logo removed?": "yes",
    "finderfilter": "ethernet modular show"
  },
  {
    "title": "RTU-4000/4100",
    "subtitle": "CARDSUBTITLES.REMOTEFIBTEST",
    "link": "/products/remote-fiber-test-system-rfts-rtu-4000-4100",
    "imgsrc": "./assets/images/Products/Remote-Fiber-Test-System-RFTS-RTU-4000-4100-plus_01.webp",
    "tag": "VeSion",
    "text1": "PRODUCTS.RTU40004100.MAINTEXT",
    "eol": "0",
    "keyword": "showall current fiber, singlemode, RFTS Remote Fiber Monitoring fiber optics, Proactive monitoring, PON monitoring,KPI,MTTR,MTTF,MTTD",
    "Meta Description": "The Remote Fiber Test System (RFTS) comprises the RTU-4000 platform with the RTU-4100 OTDR optical test module. The RFTS monitors optical fiber infrastructures in Core, Metro, Access and FTTx/PON networks with or without traffic, improving workflow and reducing Mean Time to Repair (MTTR). The RFTS can be operated in standalone mode or as part of a centralized Monitoring System.",
    "UL Logo removed?": "yes",
    "finderfilter": "modular rackmount fiber show"
  },
  {
    "title": "RXT-1200 Family",
    "subtitle": "CARDSUBTITLES.MODTESTPLAT",
    "link": "/products/rxt1200",
    "imgsrc": "./assets/images/Products/RXT1200_01.webp",
    "tag": "VeExpress",
    "text1": "PRODUCTS.RXT1200.MAINTEXT",
    "eol": "0",
    "keyword": "showall current RXT, RXT1200, RXT-1200, RXT 1200, 1200 modular test platform chassis instrument meter test set testset tester GNSS GPS veexresource",
    "Meta Description": "The RXT® is the industry’s most flexible, compact, and future-proof hand-held test solution for core, datacenter, metro, access and fiber optics applications. The forward-looking RXT-1200™ family of test platforms address the challenges of communication service providers to increase efficiency and productivity. These flexible test platforms lower operational and capital expenditures associated with handling multiple technologies required to address today’s Access, Business, Metro, Datacenter, Transport and Core services, as well as keeping up with future technologies and testing requirements. The RXT® family of modules offer a full range of link and service testing capabilities, from Core to Access, from Lab to Field and from 64k to 400G, with a complete range of communication technologies, including eCPRI, CPRI/OBSAI, OTN, SDH/SONET, PDH/DSn, Carrier Ethernet, SyncE, 1588v2 PTP, Fibre Channel, OTDR, OSA. All supported by a single rugged hand-held test platform.",
    "UL Logo removed?": "n/a",
    "finderfilter": "portable modular fiber ethernet transport show"
  },
  {
    "title": "RXT-3400",
    "subtitle": "CARDSUBTITLES.ADVMULTISERVTEST",
    "link": "/products/advanced-multi-service-test-module-rxt-3400",
    "imgsrc": "./assets/images/Products/Advanced-Multi-Service-Test-Module-RXT-3400_01.webp",
    "tag": "",
    "text1": "PRODUCTS.RXT3400.MAINTEXT",
    "eol": "0",
    "keyword": "showall current RXT, RXT1200, RXT-1200, RXT 1200, 1200 telco ethernet internet QoS QoE SLA BER BERT throughput RFC 2544 RFC6349 V-PERF iperf v-perf speed speedtest 16G 16GFC 10G 5G 2.5G 1G sdh sonet PDH DSn T1 T3 OC STS E1 fibre channel datacom ieee C37.94 CPRI OBSAI SyncE Sync jitter wander one-way dealy OWD packet capture loopback v-sam vsam sam y.1564 1564 sla qos qoe speedtest speed v-test vtest v-perf vperf iperf iperf3 rfc6349 6349",
    "Meta Description": "The RXT-3400 add-on module for the versatile RXT® test platform offers state-of-the-art support for Access, Metro, Core, Transport, Carrier Ethernet, Backhaul, Fronthaul and SAN technologies up to 16GFC. VeEX RXT® is the industry’s most flexible, compact, complete and future-proof hand-held test solution, from 64k to 400GE, including Fiber Optics and WDM.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable modular ethernet transport show"
  },
  {
    "title": "RXT-4100+",
    "subtitle": "OTDR Module for RXT-1200",
    "link": "/products/otdrmodule",
    "imgsrc": "./assets/images/Products/OTDRModule_01.webp",
    "tag": "",
    "text1": "PRODUCTS.RXT4100.MAINTEXT",
    "eol": "0",
    "keyword": "showall current OTDR, PON, fiber optic, singlemode, multimode, RXT, RXT1200, RXT-1200, RXT 1200, 1200 fiber optics",
    "Meta Description": "The RXT-4100+ Fiber Optics test module is the world’s first field portable OTDR to offer up to 500,000 data points with 3 cm resolution for the RXT1200 chassis. The RXT-4100+ OTDR modules feature a range of Optical test functions including OTDR, OPM, Light Source and VFL. Multi-protocol OTN, SDH/SONET, Ethernet, Fibre Channel and Synchronous Packet Networks utilizing optical fibers can easily be verified as well as OSA testing on CWDM/DWDM network with a single test platform ensuring maximum test productivity. Fiberizer® software for Windows® Desktop, Android™, and/or Apple® mobile devices is available to assist in data transfer, record management, and report generation for various VeEX fiber optics testers. View the Fiberizer webpage for more details.",
    "UL Logo removed?": "yes",
    "finderfilter": "portble modular fiber show"
  },
  {
    "title": "RXT-4113+",
    "subtitle": "xWDM OTDR Module for RXT-1200",
    "link": "/products/rxt4113plusmodule",
    "imgsrc": "./assets/images/Products/RXT-4113plus_01.webp",
    "tag": "",
    "text1": "PRODUCTS.RXT4113+.MAINTEXT",
    "eol": "0",
    "keyword": "showall current OTDR, xWDM, CWDM, DWDM, C-RAN, MUX, MPO, fiber optic, singlemode, RXT, RXT1200, RXT-1200, RXT 1200, 1200 fiber optics",
    "Meta Description": "The RXT-4113+ is our new generation xWDM OTDR module. Users can now select CWDM only, DWDM only or both CWDM and DWDM testing options. CWDM and/or DWDM (C-band) wavelength tuning, 3 cm resolution and up to 500,000 data points offers unprecedented network characterization for Fiber Deep, RPD, DAA and other xWDM test applications. The ability to perform attenuation profiling and verify end-to-end connectivity using a single ended test approach ensures maximum productivity.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable modular fiber show"
  },
  {
    "title": "RXT-4500/4510 Series",
    "subtitle": "CARDSUBTITLES.OSAMOD",
    "link": "/products/rxt4500module",
    "imgsrc": "./assets/images/Products/RXT4500Module_01.webp",
    "tag": "",
    "text1": "PRODUCTS.RXT4500.MAINTEXT",
    "eol": "0",
    "keyword": "showall current OSA, Optical Spectrum Analyzer, WDM, CWDM, DWDM, 10G, 40G, fiber optic, singlemode, RXT, RXT1200, RXT-1200, RXT 1200, 1200 fiber optics",
    "Meta Description": "The RXT-4500/4510 OSA modules are Optical Spectrum/Channel Analyzers for CWDM and DWDM networks. Using superior micro-optic design and MEMS tuning technology, the modules measure key optical parameters such as wavelength, channel power, and OSNR.",
    "finderfilter": "portable modular fiber show"
  },
  {
    "title": "RXT-6000e",
    "subtitle": "CARDSUBTITLES.100GMULTISERVTEST",
    "link": "/products/rxt6000emodule",
    "imgsrc": "./assets/images/Products/RXT6000eModule_01.webp",
    "tag": "",
    "text1": "PRODUCTS.RXT6000E.MAINTEXT",
    "eol": "0",
    "keyword": "showall current RXT, RXT1200, RXT-1200, RXT 1200, 1200 RXT, RXT1200, RXT-1200, RXT 1200, 1200 ethernet internet QoS QoE SLA BER BERT throughput RFC 2544 6349 iperf v-perf speed speedtest 100G 50G 40G 25G 16G 10G 5G 2.5G 1G sdh sonet PDH DSn T1",
    "Meta Description": "The RXT-6000e is the most complete and flexible portable 100G test set in the market. Equipped with most common transceiver form-factor ports and optional legacy test interfaces, this module is a perfect complement to the RXT® Platform, extending its testing range to 100 Gbps and offering up to two simultaneous 100GE tests. Installation, commissioning, monitoring and maintenance tasks are simplified thanks to a combination of intuitive features and powerful test functions. Novice users benefit from the easy-to-use GUI, while experienced users will appreciate an array of advanced features such as OTL/PCS, CAUI-4/XLAUI Lane BERT, overhead monitor/control, Tandem Connection Monitoring, Service Disruption, Protocol Capture/Decode, BERT, Throughput test, and much more.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable modular ethernet transport show"
  },
  {
    "title": "RXT-6200",
    "subtitle": "CARDSUBTITLES.100GMULTISERVTEST",
    "link": "/products/rxt6200module",
    "imgsrc": "./assets/images/Products/RXT6200Module_01.webp",
    "tag": "",
    "text1": "PRODUCTS.RXT6200.MAINTEXT",
    "eol": "0",
    "keyword": "showall current RXT, RXT1200, RXT-1200, RXT 1200, 1200 ethernet internet QoS QoE SLA BER BERT throughput RFC 2544 RFC6349 V-PERF iperf v-perf speed speedtest 100G 50G 40G 25G 32G 16G 10G 5G 2.5G 1G sdh sonet PDH DSn T1 T3 OC STS E1 fibre channel datacom ieee C37.94 CPRI OBSAI SyncE Sync jitter wander synchronization sync ptp timing time 1PPS GNSS GPS v-sam vsam sam y.1564 1564 sla qos qoe speedtest speed v-test vtest v-perf vperf iperf iperf3 rfc6349 6349",
    "Meta Description": "The RXT-6200 is the most complete and flexible portable 100G test set in the market. Equipped with most common transceiver form-factor ports and optional legacy test interfaces, this module is a perfect complement to the RXT® Platform, extending its testing range to 100 Gbps and offering up to two simultaneous 100GE tests. Installation, commissioning, monitoring and maintenance tasks are simplified thanks to a combination of intuitive features and powerful test functions. Novice users benefit from the easy-to-use GUI, while experienced users will appreciate an array of advanced features such as OTL/PCS, CAUI-4/XLAUI Lane BERT, overhead monitor/control, Tandem Connection Monitoring, Service Disruption, Protocol Capture/Decode, BERT, Throughput test, and much more.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable modular ethernet transport show"
  },
  {
    "title": "RXT-6400",
    "subtitle": "CARDSUBTITLES.400GTESTMOD",
    "link": "/products/400g-test-module",
    "imgsrc": "./assets/images/Products/RXT1200_01.webp",
    "tag": "",
    "text1": "PRODUCTS.RXT6400.MAINTEXT",
    "eol": "0",
    "keyword": "showall current RXT, RXT1200, RXT-1200, RXT 1200, 1200 ethernet internet QoS QoE SLA BER BERT throughput RFC 2544 RFC6349 iperf v-perf speed speedtest 400G 100G 50G 40G 25G 16G 10G 5G 2.5G 1G fibre channel SyncE data center transceiver DCO DAC AOC DCI ZR ZR+ coherent PAM4 400G 400GE 400ZR ZR+ OpenZR OpenZR+ OpenROADM DCO DAC Fanout Coherent DCI Datacenter Data center v-sam vsam sam y.1564 1564 sla qos qoe speedtest speed v-test vtest v-perf vperf iperf iperf3 rfc6349 6349",
    "Meta Description": "First native OSFP & QSFP-DD PAM4 400GE Test Equipment, in true portable form factor, enabling 400GE technologies’ Lab-to-Field Transition and leading the early deployment for datacenters and telcos. It offers testing capabilities from 1GE to 400GE. The RXT-6400 is the first truly portable 400G test set supporting native PAM4 QSFP-DD and OSFP. Equipped to support all common transceiver form-factors, this module is a perfect complement to the RXT Platform, extending its testing range to 400 Gbps and offering all-in-one 1GE-to-400GE testing capabilities. Installation, verification, commissioning, evaluation and maintenance tasks are simplified thanks to a combination of intuitive GUI and powerful test functions. Novice users benefit from the easy-to-use GUI, while experienced users will appreciate an array of advanced layer 1-4 features, such as FEC codeword Error distribution analysis, PAM4 pre-emphasis, skew, transceiver check and stress, Lane BERT, Throughput test, IPv4/IPv6, transceiver testing and much more.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable modular ethernet transport show"
  },
  {
    "title": "RXT-6402",
    "subtitle": "PRODUCTS.RXT6402.SUBTITLE",
    "link": "/products/rxt6402",
    "imgsrc": "./assets/images/Products/RXT-6402_01.webp",
    "tag": "",
    "text1": "PRODUCTS.RXT6402.CARDTEXT",
    "eol": "0",
    "keyword": "showall current RXT, RXT1200, RXT-1200, RXT 1200, 1200 1202 RXT1202 RXT-1202 6400 6402 RXT6400 RXT6402 RXT-6400 RXT-6402 lite hse 400G 400GE 200G 4x100G 4x100GE Nx100G Nx100GE 50G 50GE 25G 25GE 400ZR ZR+ OpenZR OpenZR+ ZR ZR+ OpenROADM QSFP QSFP-DD SFP-DD PAM4 DCO AEC AOC ACC DAC Fanout fan-out breakout break-out Coherent DCI Datacenter datacentre Data center centre NEM mpm mpa r&d r+d FAE design manufacturing automation script scripting scpi svt development transceiver veexresource v-sam vsam sam y.1564 1564 sla qos qoe speedtest speed v-test vtest v-perf vperf iperf iperf3 rfc6349 6349 Ethernet test throughput layer1 layer2 layer3 layer4",
    "Meta Description": "VeEX® RXT is the industry’s most flexible, compact, and future- proof handheld test solution for Core, Metro, Datacenter, and Access applications. The RXT-6402 Dual 400G offers the flexibility of testing current interfaces and supporting future expandability for applications including Transport, Aggregation, cross-connect, 5G x-haul, and NEMs field support. 400G Down to 10M Ethernet Testing; OTN, SDH/SONET, PDH/DSn; Fibre Channel",
    "UL Logo removed?": "yes",
    "finderfilter": "portable modular ethernet transport show"
  },
  {
    "title": "RXT-6802",
    "subtitle": "Advanced 800G Multi-service Test Module",
    "link": "/products/rxt6802module",
    "imgsrc": "./assets/images/Products/RXT-6802_01.webp",
    "tag": "New",
    "text1": "PRODUCTS.RXT6802.MAINTEXT1",
    "eol": "0",
    "keyword": "showall current RXT, RXT1200, RXT-1200, RXT 1200, 1200 1202 RXT1202 RXT-1202 6800 6802 RXT6800 RXT6802 RXT-6800 RXT-6802 lite hse 800G 800GE 8x100G 8x100GE 400G 400GE 200G 4x100G 4x100GE Nx100G Nx100GE 50G 50GE 25G 25GE 400ZR ZR+ OpenZR OpenZR+ ZR ZR+ OpenROADM QSFP QSFP-DD SFP-DD PAM4 DCO AEC AOC ACC DAC Fanout fan-out breakout break-out Coherent DCI Datacenter datacentre Data center centre NEM mpm mpa r&d r+d FAE design manufacturing automation script scripting scpi svt development transceiver veexresource v-sam vsam sam y.1564 1564 sla qos qoe speedtest speed v-test vtest v-perf vperf iperf iperf3 rfc6349 6349 Ethernet test throughput layer1 layer2 layer3 layer4 pressrelease",
    "Meta Description": "VeEX® RXT is the industry’s most flexible, compact, and future-proof handheld test solution for Core, Metro, Datacenter, and Access applications. The RXT-6802 and RXT-6802 Lite offers the flexibility of testing current interfaces and supporting future expandability for applications including Transport, Aggregation, cross-connect, 5G x-haul, and NEMs field support.",
    "UL Logo removed?": "n/a",
    "finderfilter": "portable modular fiber ethernet transport show"
  },
  {
    title: 'RXT-6811',
    subtitle: 'Advanced 800G Multi-service Test Module',
    link: '/products/rxt6811module',
    imgsrc: './assets/images/Products/RXT-6811_01.webp',
    tag: 'New',
    text1: 'PRODUCTS.RXT6811.MAINTEXT1',
    portable: 'YES',
    catv: '',
    show: 'YES',
    eol: '0',
    keyword: 'showall current RXT, RXT1200, RXT-1200, RXT 1200, 1200 1202 RXT1202 RXT-1202 6800 6811 RXT6800 RXT6811 RXT-6800 RXT-6811 lite hse 800G 800GE 8x100G 8x100GE 400G 400GE 200G 4x100G 4x100GE Nx100G Nx100GE 50G 50GE 25G 25GE 400ZR ZR+ OpenZR OpenZR+ ZR ZR+ OpenROADM QSFP OSFP QSFP-DD SFP-DD PAM4 DCO AEC AOC ACC DAC Fanout fan-out breakout break-out Coherent DCI Datacenter datacentre Data center centre NEM mpm mpa r&d r+d FAE design manufacturing automation script scripting scpi svt development transceiver veexresource v-sam vsam sam y.1564 1564 sla qos qoe speedtest speed v-test vtest v-perf vperf iperf iperf3 rfc6349 6349 Ethernet test throughput layer1 layer2 layer3 layer4 pressrelease',
    "Meta Description": "VeEX® RXT is the industry’s most flexible, compact, and future- proof handheld test solution for Core, Metro, Datacenter, and Access applications. The RXT-6811 800G/Dual 400G offers the flexibility of testing current interfaces and supporting future expandability for applications including Transport, Aggregation, cross-connect, 5G x-haul, and NEMs field support.",
    "finderfilter": "portable modular fiber ethernet transport show"
  },
  {
    "title": "SWP-BOX™",
    "subtitle": "PRODUCTS.SWP-BOX.SUBTITLE",
    "link": "/products/swp-box",
    "imgsrc": "./assets/images/Products/SWP-BOX_01.webp",
    "tag": "DOCSIS 3.X/4.0",
    "text1": "PRODUCTS.SWP-BOX.MAINTEXT",
    "eol": "0",
    "keyword": "showall current CATV, HFC, Meter, Network, OSP, ISP, Maintenance, Headend, DOCSIS 4.0, OFDM, Extended Spectrum, 1.8 GHz, Sweep, CaLan, Drop Certification, Coax, VeCheck, Return Path Sweep, Forward Path Sweep, 204 MHz, 85 MHz, High-Split, Mid-Split, OFDMA, Portable, Prequalification, Plant, R-Phy, DAA, ESD, Active, Passive, Amplifier, Tap, DC",
    "Meta Description": "Rugged, portable device for pre-qualification and maintenance of CATV plant spectrum expansion to 1.8 GHz. Comprises a complete field Sweep System with the CX380C Field Maintenance Meter, for Forward and Return Path Sweep",
    "UL Logo removed?": "yes",
    "finderfilter": "portable catv show"
  },
  {
    "title": "Test with Flow®",
    "subtitle": "SaaS Workflow Management and Result Repository",
    "link": "/testwithflow",
    "imgsrc": "./assets/images/testwithflow/mobile_view_banner.webp",
    "tag": "",
    "text1": "Telecommunication installations and maintenance require extensive testing, generating numerous individual reports from various equipment. VeEX’s Test with Flow® cloud service centralizes, analyzes, and securely stores all test report data in one place. Ideal for small providers and contractors, it offers control without hardware and IT costs. Subscription-based, scalable from small businesses to enterprises, it\'s a perfect choice for rural operators and contractors. ",
    "eol": "0",
    "keyword": "showall current other qr qrcode qr code scan app fx fiber ethernet no app pdf json rserver r-server cloud result results company project email sms text  speed test speedtest fault locator flow",
    "Meta Description": "Telecommunication installations and maintenance require extensive testing, generating numerous individual reports from various equipment. VeEX’s Test with Flow® cloud service centralizes, analyzes, and securely stores all test report data in one place. Ideal for small providers and contractors, it offers control without hardware and IT costs. Subscription-based, scalable from small businesses to enterprises, it\'s a perfect choice for rural operators and contractors. ",
    "UL Logo removed?": "yes",
    "finderfilter": ""
  },
  {
    "title": "TX300s Family",
    "subtitle": "CARDSUBTITLES.MULTISERVTESTPLAT",
    "link": "/products/tx300s",
    "imgsrc": "./assets/images/Products/TX300S_03.webp",
    "tag": "VeExpress",
    "text1": "PRODUCTS.TX300SFAMILY.MAINTEXT",
    "eol": "0",
    "keyword": "showall current TX300s test platform chassis instrument meter test set testset tester GNSS GPS fiber optics veexresource",
    "Meta Description": "VeEX® VePAL TX300s Family is a fully-integrated and self-contained multi-service test solution for OTN, SDH, SONET, PDH, DSn, Fibre Channel, Ethernet, Mobile Backhaul, CPRI/OBSAI and Fiber Optics networks. Equipped with SyncE, 1588v2 PTP, and CPRI/OBSAI test options, the unit offers unprecedented synchronization turn-up and troubleshooting test functions for mobile operators migrating to 4G LTE. Powered by the VeExpress™ system, TX300s users are able to share test options, either purchased or leased, with multiple devices, dramatically reducing Opex and Capex.",
    "undefined": "remove HR",
    "finderfilter": "portable ethernet transport show"
  },
  {
    "title": "TX300s 100GX",
    "subtitle": "CARDSUBTITLES.100GTESTMOD",
    "link": "/products/tx300s100goption",
    "imgsrc": "./assets/images/Products/TX300S_03.webp",
    "tag": "",
    "text1": "PRODUCTS.TX300S100G.MAINTEXT",
    "eol": "0",
    "keyword": "showall current TX300s ethernet internet QoS QoE SLA BER BERT throughput RFC 2544 RFC6349 V-PERF iperf v-perf speed speedtest 100G 50G 40G 25G 16G 10G 5G 2.5G 1G sdh sonet PDH DSn T1 T3 OC STS E1 fibre channel datacom ieee C37.94 CPRI OBSAI SyncE Sync jitter wander synchronization sync ptp timing time 1PPS GNSS GPS v-sam vsam sam y.1564 1564 sla qos qoe speedtest speed v-test vtest v-perf vperf iperf iperf3 rfc6349 6349",
    "Meta Description": "The TX300s-100G modules offer a variety of latest or legacy in pluggable optical interface technologies. It is a perfect complement to the TX300s Platform, extending its testing range to 100 Gbps. In combination with the TX340sm module, it offers a complete multi-service test solution from 64k to 100G, in a compact portable package. Installation, commissioning, monitoring and maintenance of Ethernet, OTN or SDH/SONET networks is simplified thanks to a combination of intuitive features and powerful test functions. Fast troubleshooting and comprehensive analysis of transmission problems can be performed using its common graphical user interface. Novice users benefit from the easy-to-use GUI, while experienced users will appreciate an array of advanced features such as OTL/PCS, CAUI-4/XLAUI Lane BERT, Service Disruption, overhead monitor/control, Tandem Connection Monitoring, Protocol Capture/Decode, BERT, Throughput test, and much more.",
    "finderfilter": "portable ethernet transport show"
  },
  {
    "title": "TX300s OTDR",
    "subtitle": "OTDR option for TX300s Family",
    "link": "/products/tx300sotdroption",
    "imgsrc": "./assets/images/Products/TX300sOTDROption_01.webp",
    "tag": "",
    "text1": "PRODUCTS.TX300SOTDR.MAINTEXT",
    "eol": "0",
    "keyword": "showall current OTDR, PON, fiber optic, singlemode, multimode, ethernet TX300s",
    "Meta Description": "The Fiber Optics test option for the VeEX® VePAL TX300s adds a full range of Optical test features that support OTDR, OPM, Light Source and VFL. Together with Advanced OTN, SDH/SONET, PDH/DSn, Ethernet, Fibre Channel, and Synchronous Packet Networks support, the TX300s offers a complete network test solution from physical layer up to higher layers of multi-service performance testing. Fiberizer® software for Windows® Desktop, Android™, and/or Apple® mobile devices is available to assist in data transfer, record management, and report generation for various VeEX fiber optics testers. View the Fiberizer webpage for more details.",
    "finderfilter": "portable ethernet transport show"
  },
  {
    "title": "TX340s",
    "subtitle": "CARDSUBTITLES.ADVMULTISERVTEST",
    "link": "/products/tx340sadvancedmultiserviceoption",
    "imgsrc": "./assets/images/Products/TX340sAdvancedMultiServiceOption_01.webp",
    "tag": "",
    "text1": "PRODUCTS.TX340S.MAINTEXT",
    "eol": "0",
    "keyword": "showall current C37.94 37 94 C37 TX300s telco ethernet internet QoS QoE SLA BER BERT throughput RFC 2544 6349 iperf v-perf speed speedtest 16G 10G 5G 2.5G 1G sdh sonet PDH DSn T1 T3 OC STS E1 fibre channel datacom ieee C37.94 CPRI OBSAI SyncE Sync jitter wander synchronization sync ptp timing time 1PPS GNSS GPS v-sam vsam sam y.1564 1564 sla qos qoe speedtest speed v-test vtest v-perf vperf iperf iperf3 rfc6349 6349",
    "Meta Description": "The TX340s hardware option for the TX300s portable test platform offers advanced test solutions for OTN, SONET/SDH, PDH/DSn, Carrier Ethernet, Fibre Channel and CPRI/OBSAI. This factory-installed hardware option allows flexibility to fit any application, for example, the addition of a second TX340s, 100G or OTDR module, to be installed concurrently in the same test platform.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber ethernet transport show"
  },
  {
    "title": "VeSion®",
    "subtitle": "CARDSUBTITLES.CLOUDNETMON",
    "link": "/server/vesion",
    "imgsrc": "./assets/images/Products/VeSion-Transparent_01.webp",
    "tag": "",
    "text1": "SOFTWARE.VESION.MAINTEXT1",
    "eol": "0",
    "keyword": "showall current sweep ingress return path rf monitoring docsis pnm fiber workflow asset management MSO NOC cable modem",
    "Meta Description": "VeEX’s VeSion is a cloud-based one system platform, representing the next step in innovation. It integrates VeEX’s Preventive RF Monitoring (Return and Forward), Fiber and PNM (Return and Forward), MPEG, Ethernet, Advanced DOCSIS Monitoring, DOCSIS Burst Demodulation, Sweep, Workflow and Asset Management systems all under one umbrella. This provides MSO’s complete network visibility (VeSion) and reduces unnecessary Truck Rolls by alerting key personnel via SMS and/or emails to alarm conditions and location. In addition, VeSion links directly with an MSO’s billing system, allowing them to pin-point the exact location of the DOCSIS cable modem problem. With the one system platform, maintenance is easy and secure while reducing the effort to maintain several separate systems by MSO NOC teams. Along with the VeSion R-Server, it is the perfect workforce management tool to keep devices up-to-date in the field. Using the Internet, or mobile applications to VeSion, access to all of your results can be made anywhere, anytime and at any location.",
    "UL Logo removed?": "n/a",
    "finderfilter": "software show"
  },
  {
    "title": "VeSion® R-Server",
    "subtitle": "CARDSUBTITLES.CLOUDWORKASSMAN",
    "link": "/server/rserver",
    "imgsrc": "./assets/images/Products/R-server_01.webp",
    "tag": "",
    "text1": "SOFTWARE.VESIONRSERVER.MAINTEXT1",
    "eol": "0",
    "keyword": "showall current centralized monitoring mso workflow asset jobs ticketing jobs, saas, software, server, workforce, management, process test profile workforce",
    "Meta Description": "Part of VeEX’s VeSion® centralized monitoring and management solutions, the R-Server Workflow and Asset Management system provides crucial tools to manage fleets of technicians, test equipment, standardized test profiles, thresholds, centralized test results collection, reporting, jobs/ticketing, and software update delivery to create coordinated and efficient disciplined workforce and test procedures. R-Server enhances the workflow to achieve the level of quality and repeatability required by telecommunications service providers, MSOs and their contractors. The flexible R-Server can be deployed in cloud, hosted, and corporate networks, on physical or virtualized servers. R-Server prioritizes organization, navigation, and speed as key characteristics. This provides administrators with a detailed overview of all regions in seconds and allows managers to focus on their own regions, districts, and/or systems. For technicians, it provides a central system to upload results and download profiles. Supervisors can upload test parameters and compile it into a profile. Technicians can download this profile with all parameters preset for a quick and error-free testing experience. Once the test is carried out, the technician can upload the result to R-Server, which stores and protects the data. No need to worry about losing test results ever again.",
    "UL Logo removed?": "n/a",
    "finderfilter": "software show"
  },
  {
    "title": "WX90",
    "subtitle": "CARDSUBTITLES.WIFIEXPERTTOOLKIT",
    "link": "/products/wx90",
    "imgsrc": "./assets/images/Products/WX90_01.webp",
    "tag": "New",
    "text1": "PRODUCTS.WX150.MAINTEXT",
    "eol": "0",
    "keyword": "showall current Wi-Fi Tester, Spectrum Analyzer, Wi-Fi QoE Validation, Wireless Network Testing, Internet Speed Test, 6GHz Testing, Multi-Band Spectrum Analyzer, Channel Scan, Wi-Fi Analyzer",
    "Meta Description": "Built for modern network deployments, it offers robust Wi-Fi testing with a spectrum analyzer covering 2.4, 5 and 6 GHz. With Internet QoE validation, it empowers technicians to diagnose, optimize and maintain high-speed Wi-Fi networks, making it essential for both residential and enterprise environments.",
    "finderfilter": "portable wifi wi-fi show"
  }
];

export const previousproductcards = [{
    title: 'CX100+',
    subtitle: '',
    link: '/products/cx100-plus',
    imgsrc: './assets/images/Products/CX100-plus_01.webp',
    replaced: 'CX310',
    replacedlink: '/products/docsis-31-installation-tool-cx310',
    tag: '',
    text1: 'CATV installer meter to characterize and measure Analog and Digital video signals.',
    portable: 'YES',
    catv: 'YES',
    show: 'YES',
    eol: '2',
    keyword: 'showall previous'
  },
  {
    title: 'CX150-D3+ (red)',
    subtitle: '',
    link: '/products/cx150d3red-plus',
    imgsrc: './assets/images/Products/CX150D3red-plus_01.webp',
    replaced: 'CX310',
    replacedlink: '/products/docsis-31-installation-tool-cx310',
    tag: '',
    text1: 'The compact, handheld CX150-D3+ is comprised of a feature rich SLM with an embedded DOCSIS 3.0 Cable Modem supporting full 8x4 Channel Bonding.',
    portable: 'YES',
    catv: 'YES',
    show: 'YES',
    eol: '2',
    keyword: 'showall previous'
  },
  {
    "title": "CX180R",
    "subtitle": "CARDSUBTITLES.CATVRET",
    "link": "/products/cx180r",
    "imgsrc": "./assets/images/Products/CX180R_01.webp",
    replaced: 'CX180R+',
    replacedlink: '/products/cx180r-plus',
    "tag": "VeSion",
    "text1": "PRODUCTS.CX180R.MAINTEXT",
    "eol": "2",
    "keyword": "showall previous CATV, HFC, Monitoring System, Monitoring Probe, Return Path, Upstream, VeSion, Troubleshooting, Node Health, Proactive Maintenance, Alarm, Coax, VeNode",
    "Meta Description": "The VeSion® Return system monitors the return path for noise, UCD and ingress that interfere with DOCSIS communications. With DOCSIS 3.0/3.1 deployments, higher order upstream QAM modulation and channel bonding are more vulnerable to ingress and should be monitored continuously to ensure peak performance. As part of the VeSion system, the CX180R sets new standards for form factor and performance. The space saving 1U rack mount unit integrates multiple DSP based test resources dedicated to 10 nodes in each system. Each CX180R unit supports three different test modes simultaneously and independently. In ingress scan mode, fast transients can be identified at a scan rate of up to 250ms per node. In spectrum analyzer mode, on demand RF signal analysis using optimal programmable RBW and dwell time can be performed.",
    "UL Logo removed?": "yes",
    "finderfilter": "rackmount catv show"
  },
  {
    title: 'CX350s-D3.1',
    subtitle: 'CATV Installation Test Set',
    link: '/products/cx350sd31',
    imgsrc: './assets/images/Products/CX350sD31_01.webp',
    replaced: 'CX310',
    replacedlink: '/products/docsis-31-installation-tool-cx310',
    tag: 'DOCSIS 3.0/3.1',
    text1: 'PRODUCTS.CX350SD31.MAINTEXT',
    portable: 'YES',
    catv: 'YES',
    show: 'YES',
    eol: '2',
    keyword: 'showall previous CATV, HFC, Meter, Installer, Fulfillment, Forward Path, DOCSIS 3.1, OFDM, Home Certification, HIP, Drop Certification, Coax, VeCheck, Subcarrier Scan'
  },
  {
    title: 'CX380s-D3.1',
    subtitle: 'CARDSUBTITLES.SUPERTECHMAIN',
    link: '/products/cx380sd31',
    imgsrc: './assets/images/Products/CX380sD31_01.webp',
    replaced: 'CX380C',
    replacedlink: '/products/cx380c',
    tag: 'DOCSIS 3.X/4.0',
    text1: 'PRODUCTS.CX380SD31.MAINTEXT',
    portable: 'YES',
    catv: 'YES',
    show: 'YES',
    eol: '2',
    keyword: 'showall previous CATV, HFC, Meter, Network, OSP, ISP, Maintenance, Headend, DOCSIS 3.1, OFDM, Extended Spectrum, 1.8 GHz, Sweep, Ingress, Coax, VeCheck, Subcarrier Scan, FCC POP, MPEG, Ethernet, 10 Gigabit Ethernet, Return Path, Forward Path'
  },
  {
    "title": "MTTplus-320",
    "subtitle": "CARDSUBTITLES.MULTISERVTESTMOD",
    replaced: 'MTTplus-340',
    replacedlink: '/products/mttplus-340',
    "link": "/products/mttplusmultiservicetestmoduleoption",
    "imgsrc": "./assets/images/Products/MTTplusMultiServiceTestModuleOption_01.webp",
    "tag": "",
    "text1": "PRODUCTS.MTTPLUS320.MAINTEXT",
    "eol": "2",
    "keyword": "showall previous mtt-plus mtt plus mtt-320 telco ethernet internet QoS QoE SLA BER BERT throughput RFC 2544 6349 iperf v-perf speed speedtest 10G 1G sdh sonet PDH DSn T1 T3 OC STS E1 fibre channel datacom ieee C37.94 CPRI OBSAI SyncE Sync jitter wander",
    "Meta Description": "The MTTplus-320 Multi-Service Module is a full-featured test solution for OTN, SONET, SDH, PDH, DSn, 64k Codirectional, C37.94, Carrier Ethernet, Fibre Channel, SyncE, PTP and CPRI/OBSAI.",
    "undefined": "HR/LR",
    "finderfilter": "portable modular ethernet transport show"
  },
  {
    title: 'RTU-600',
    subtitle: '100G Test Module',
    replaced: 'RTU-600x',
    replacedlink: '/products/rtu-600x',
    link: '/products/rtu-600',
    imgsrc: './assets/images/Products/RTU-600_01.webp',
    tag: '',
    text1: 'The RTU-600 hardware option for the RTU-300 standalone platform offers a full-featured centralized test solution for Ethernet, Mobile Backhaul, Storage Area Networks, OTN, SDH/SONET links and services testing — 40 Gbps and 100 Gbps. This factory-installed hardware option allow flexibility to fit any application. Available in QSFP28/QSFP+ version.',
    ethernet: 'YES',
    modular: 'YES',
    show: 'YES',
    eol: '2',
    keyword: 'showall previous'
  },
  {
    title: 'RXT-3000',
    subtitle: '',
    replaced: 'RXT-3400',
    replacedlink: '/products/advanced-multi-service-test-module-rxt-3400',
    tag: '',
    text1: 'The RXT-3000 Multi-service Module is a full-featured test solution for OTN, SDH, SONET, PDH, DSn networks, and offers extensive support for Mobile Backhaul technologies with SyncE, 1588v2 PTP, Carrier Ethernet, Fibre Channel and CPRI/OBSAI testing. ',
    portable: 'YES',
    modular: 'YES',
    ethernet: 'YES',
    transport: 'YES',
    show: 'YES',
    eol: '2',
    imgsrc: './assets/images/Products/RXT3000Module_01.webp',
    link: '/products/rxt3000module',
    keyword: 'showall previous RXT, RXT1200, RXT-1200, RXT 1200, 1200'
  },
  {
    title: 'RXT-6000',
    subtitle: '',
    link: '/products/rxt6000module',
    eol: '2',
    keyword: 'showall previous RXT, RXT1200, RXT-1200, RXT 1200, 1200',
    text1: 'The RXT-6000 module, with the latest technology in pluggable physical interfaces, is a perfect complement to the RXT® Platform, extending its testing range to 100 Gbps. Installation, commissioning, monitoring and maintenance of Ethernet, Fibre Channel, OTN and SDH/SONET networks is simplified thanks to a combination of intuitive features and powerful test functions. ',
    imgsrc: './assets/images/Products/RXT6000Module_01.webp',
    replaced: 'RXT-6200',
    replacedlink: '/products/rxt6200module',
  },
  {
    "title": "RXT-6800",
    "subtitle": "Advanced 800G Multi-service Test Module",
    "link": "/products/rxt6800module",
    "imgsrc": "./assets/images/Products/RXT6800_Module_01.webp",
    "tag": "",
    "text1": "PRODUCTS.RXT6800.MAINTEXT",
    "eol": "2",
    "keyword": "showall previous v-sam vsam sam y.1564 1564 sla qos qoe speedtest speed v-test vtest v-perf vperf iperf iperf3 rfc6349 6349 pressrelease",
    "Meta Description": "VeEX® RXT is the industry’s most flexible, compact, and future- proof handheld test solution for Core, Metro, Datacenter, and Access applications. The RXT-6800 800G/Dual 400G offers the flexibility of testing current interfaces and supporting future expandability for applications including Transport, Aggregation, cross-connect, 5G x-haul, and NEMs field support.",
    "UL Logo removed?": "n/a",
    "finderfilter": "portable modular fiber ethernet transport show",
    replaced: 'RXT-6802',
    replacedlink: '/products/rxt6802module',
  },
  // {
  //     title: 'TLS-1000',
  // subtitle: '',
  //     link: '/products/tls1000',
  //     eol: '2',
  //     keyword: 'discontinued previous showall tls tls1000 tls-1000',
  //     text1: 'The VeEX TLS-1000 Family of Tunable Laser Sources is designed to provide a new level of high performance testing and increased test efficiency by incorporating fastest swept-wavelength test ≥ 200 nm/s while reducing cost of ownership. ',
  //     imgsrc: './assets/images/Products/480-TLS1000_01.webp'
  // },
  {
    title: 'TX130M+',
    subtitle: '',
    link: '/products/tx130m-plus',
    imgsrc: './assets/images/Products/TX130M-plus_01.webp',
    replaced: 'MTX150',
    replacedlink: '/products/mtx150',
    tag: '',
    text1: 'The VePAL TX130M+ is a full-featured Mobile Backhaul test solution supporting legacy PDH/DSn, Carrier Ethernet technologies, and Synchronized Packet networks.',
    portable: 'YES',
    ethernet: 'YES',
    transport: 'YES',
    show: 'YES',
    eol: '2',
    keyword: 'showall previous'
  },
  {
    title: 'TX150/E+',
    subtitle: '',
    link: '/products/tx150e-plus',
    replaced: 'MTX150',
    replacedlink: '/products/mtx150',
    eol: '2',
    keyword: 'showall previous',
    text1: 'The TX150/E+ is a compact and ruggedized tester for installing, commissioning and troubleshooting SDH, SONET, PDH and T-Carrier networks. Configuration of the test setup is simplified by the color touch-screen, test system block diagram and intuitive menu structure and shortcuts.',
    imgsrc: './assets/images/Products/TX150E-plus_01.webp'
  },
  {
    title: 'TX150/E+ (red)',
    subtitle: '',
    link: '/products/tx150ered-plus',
    imgsrc: './assets/images/Products/TX150Ered-plus_01.webp',
    replaced: 'MTX150',
    replacedlink: '/products/mtx150',
    tag: '',
    text1: 'The TX150/E+ is a compact and ruggedized tester for installing, commissioning and troubleshooting SDH, SONET, PDH, T-Carrier and G.703 64k Codirectional networks.',
    portable: 'YES',
    transport: 'YES',
    show: 'YES',
    eol: '2',
    keyword: 'showall previous'
  },
  {
    title: 'TX300s XFP/SFP',
    subtitle: '',
    replaced: 'TX340s',
    replacedlink: '/products/tx340sadvancedmultiserviceoption',
    tag: '',
    text1: 'A full featured portable test solution for OTN, SDH, SONET, PDH,DSn, Carrier Ethernet, Fibre Channel, CPRI/OBSAI networks as well as synchronization verification tests.The TX300s hardware option offers extensive support for Mobile Backhaul technologies with SyncE, 1588v2 PTP and CPRI/OBSAI Fronthaul. Up to two TX300s modules can be factory-installed in the TX300s platform, for full dual-port and independent dual-test capabilities ',
    portable: 'YES',
    ethernet: 'YES',
    transport: 'YES',
    show: 'YES',
    eol: '2',
    imgsrc: './assets/images/Products/TX300S_01.webp',
    link: '/products/tx300sxfpsfpoption',
    keyword: 'showall previous TX300s'
  },
  {
    title: 'TX320s',
    subtitle: '',
    link: '/products/tx320sdualsfpplusoption',
    imgsrc: './assets/images/Products/TX320sDualSFPplusOption_05.webp',
    replaced: 'TX340s',
    replacedlink: '/products/tx340sadvancedmultiserviceoption',
    tag: '',
    text1: 'The dual test port hardware option for the TX300s platform offers a full-featured portable test solution for OTN, SONET/SDH, PDH/DSn, Carrier Ethernet, Fibre Channel and CPRI/OBSAI networks, as well as Synchronization verification tests. This factory-installed hardware option allows the addition of other applications, for example, OTDR, to be installed concurrently in the same test platform.',
    portable: 'YES',
    fiber: 'YES',
    ethernet: 'YES',
    transport: 'YES',
    show: 'YES',
    eol: '2',
    keyword: 'showall previous'
  },
  {
    title: 'UX400',
    subtitle: '',
    link: '/products/ux400',
    imgsrc: './assets/images/Products/UX400_01.webp',
    replaced: 'RTU-300+',
    replacedlink: '/products/rtu-300plus',
    tag: '',
    text1: 'The VeEX UX400 is the smallest multi-service transport test solution to offer test capabilities ranging from DS1/E1 all the way up to 6x 100G traffic generation, supporting the latest 100G/40G optical pluggable form factors (CFP4, CFP2, CFP, QSFP28, QSFP+, no adapters required). Its modular architecture allows for up to six independent test modules and up to twelve concurrent tests or combinations of tests, including legacy PDH/DSn, SDH/SONET, OTN, Ethernet, Fibre Channel, CPRI/OBSAI, C/DWDM spectrum analysis and more. The platform\'s software architecture has been developed so that multiple users or scripts are able to access and operate different test modules at the same time, maximizing the use of resources. A battery backup option is available for the portable UX400 platform. Test modules can also operate in a standard 19\' rack – the UX400R, when portability or battery operation is not needed.',
    portable: 'YES',
    modular: 'YES',
    fiber: 'YES',
    ethernet: 'YES',
    transport: 'YES',
    show: 'YES',
    eol: '2',
    keyword: 'showall previous TX300s'
  },
  {
    title: 'UX400-100G',
    subtitle: '',
    replaced: 'RTU-600x',
    replacedlink: '/products/rtu-600x',
    tag: '',
    text1: 'This multi CFP form-factor high-speed OTN, SDH/SONET and Ethernet test module offers up to 600G traffic generation for development, verification and commissioning for today’s demanding speed requirements. As well as all the standard installation and maintenance tests, including advanced features such as OTL/STL/PCS, CAUI/XLAUI Lane BERT, overhead monitoring and byte control, Tandem Connection Monitoring, protocol capturing and decoding, traditional BERT and throughput tests, advanced OTN/SDH/SONET/PDH/DSn payload multiplexing and much more. ',
    portable: 'YES',
    modular: 'YES',
    ethernet: 'YES',
    transport: 'YES',
    show: 'YES',
    eol: '2',
    imgsrc: './assets/images/Products/UX40040G100GModule_01.webp',
    link: '/products/ux40040g100gmodules',
    keyword: 'showall previous'
  },
  {
    title: 'UX400-10G',
    subtitle: '',
    replaced: 'RTU-340',
    replacedlink: '/products/rtu-340',
    tag: '',
    text1: 'Simplified installation, commissioning, monitoring and maintenance of OTU2/2e, STM-64, OC192, 10G Ethernet and 8/10G Fibre Channel networks, thanks to a combination of intuitive features and powerful test functions. Fast troubleshooting and comprehensive analysis of transmission problems can be performed using intrusive, non-intrusive and monitoring test modes. Its dual interface allows high port density testing (e.g. 10x 10GE into a 100G). ',
    portable: 'YES',
    modular: 'YES',
    ethernet: 'YES',
    transport: 'YES',
    show: 'YES',
    eol: '2',
    imgsrc: './assets/images/Products/UX400Dual10GModule_01.webp',
    link: '/products/ux40010gmodule',
    keyword: 'showall previous'
  },
  {
    title: 'UX400-16G',
    subtitle: '',
    replaced: 'RTU-340',
    replacedlink: '/products/rtu-340',
    tag: '',
    text1: 'Offers multi-rate wire-speed traffic generation at all commercially available Fibre Channel rates with FC-2 BERT for link integrity testing. Also supports latency and buffer-to-buffer credit measurements for SAN installation, commissioning and troubleshooting tasks. ',
    portable: 'YES',
    modular: 'YES',
    ethernet: 'YES',
    transport: 'YES',
    show: 'YES',
    eol: '2',
    imgsrc: './assets/images/Products/UX400Dual16GFCModule_01.webp',
    link: '/products/ux40016gfibrechannelmodule',
    keyword: 'showall previous'
  },
  {
    title: 'UX400-1GE',
    subtitle: '',
    replaced: 'RTU-340',
    replacedlink: '/products/rtu-340',
    tag: '',
    text1: 'Provides testing for 10/100/1000 Ethernet and 1/2/4 G Fibre Channel technologies, with support for industry standard tests like RFC2544 and loopback tests . The Ethernet module also offers synchronization protocol testing tools with SyncE and 1588v2/PTP support. ',
    portable: 'YES',
    modular: 'YES',
    ethernet: 'YES',
    transport: 'YES',
    show: 'YES',
    eol: '2',
    imgsrc: './assets/images/Products/UX400Dual1GEModule_01.webp',
    link: '/products/ux4001gemodule',
    keyword: 'showall previous'
  },
  {
    title: 'UX400-2.5G',
    subtitle: '',
    replaced: 'RTU-340',
    replacedlink: '/products/rtu-340',
    tag: '',
    text1: 'Adds lower rate testing for OTU1, SDH, SONET, legacy PDH and DSn/T-carrier interfaces, is a perfect, complement to the UX400R, increasing its port density and enabling a full range of link testing, capabilities from DS1/E1 to OTU4. ',
    portable: 'YES',
    modular: 'YES',
    ethernet: 'YES',
    transport: 'YES',
    show: 'YES',
    eol: '2',
    imgsrc: './assets/images/Products/UX400Dual2point5GModule_01.webp',
    link: '/products/ux4002point5gmodule',
    keyword: 'showall previous'
  },
  {
    title: 'UX400-40G',
    subtitle: '',
    link: '/products/ux40040gmodule',
    replaced: 'RTU-600x',
    replacedlink: '/products/rtu-600x',
    eol: '2',
    keyword: 'showall previous',
    text1: 'The UX400-40G module, with its physical interface for OTU3, STM-256 and OC-768 testing, adds to the UX400’s full range of link and service testing capabilities for a complete DS1 to OTU4, in a single compact unit. ',
    imgsrc: './assets/images/Products/480-UX40040GModule_01.webp'
  },
  // {
  //     title: 'UX400-40G',
  // subtitle: '',
  //     tag: '',
  //     text1: '',
  //     portable: 'YES',
  //     modular: 'YES',
  //     ethernet: 'YES',
  //     transport: 'YES',
  //     show: 'YES',
  //     eol: '0',
  //     imgsrc: './assets/images/Products/UX40040G100GModule_01.webp',
  //     link: '/products/ux40040gmodule'
  // keyword: 'showall previous'
  // },
  {
    title: 'UX400-COMBO',
    subtitle: '',
    replaced: 'RTU-340',
    replacedlink: '/products/rtu-340',
    tag: '',
    text1: 'Convenient all-in-one test solution for OTN, SDH, SONET, PDH, DSn networks, combined with extensive support for Mobile Backhaul technologies such as SyncE, 1588v2 PTP, Carrier Ethernet, Fibre Channel, CPRI/OBSAI and Synchronization testing. Ideal for modern multi-technology end-to-end service verification. ',
    portable: 'YES',
    modular: 'YES',
    ethernet: 'YES',
    transport: 'YES',
    show: 'YES',
    eol: '2',
    imgsrc: './assets/images/Products/UX400MultiServiceModule_02.webp',
    link: '/products/ux400multiservicemodule',
    keyword: 'showall previous'
  },
  {
    title: 'UX400-OSA',
    subtitle: '',
    // replaced: 'RXT-4500/4510 Series',
    // replacedlink: '/products/rxt4500module',
    tag: '',
    text1: 'Optical Spectrum and Advanced Channel Analyzer for CWDM and DWDM Networks. Using state-of-the-art micro-optic design and MEMS tuning technology, the UX400 OSA module measures all key optical parameters with simplicity, accuracy and robustness. High reliability is achieved through a rugged mechanical design with no moving parts that does not require periodic calibration. ',
    portable: 'YES',
    modular: 'YES',
    fiber: 'YES',
    show: 'YES',
    eol: '2',
    imgsrc: './assets/images/Products/UX400OSAModule_01.webp',
    link: '/products/ux400osamodule',
    keyword: 'showall previous'
  },
  {
    title: 'WX150',
    subtitle: 'CARDSUBTITLES.WIFIAIREXPERTTEST',
    link: '/products/wx150',
    imgsrc: './assets/images/Products/WX150_01.webp',
    replaced: 'WX150 Wi-Fi',
    replacedlink: '/products/wx150-wifi',
    tag: '',
    text1: 'PRODUCTS.WX150.MAINTEXT',
    portable: 'YES',
    wifi: 'YES',
    show: 'YES',
    eol: '2',
    keyword: 'showall previous wifi wi-fi'
  },
  {
    "title": "WX150 Wi-Fi",
    "subtitle": "CARDSUBTITLES.WIFIAIREXPERTTEST",
    "link": "/products/wx150-wifi",
    "imgsrc": "./assets/images/Products/WX150-WIFI6_01.webp",
    "tag": "",
    "text1": "PRODUCTS.WX150.MAINTEXT",
    "eol": "2",
    "keyword": "showall previous",
    "Meta Description": "VeEX’s Wi-Fi Air Expert® provides the tools for reliable, repeatable install procedures that go beyond RF layer analysis. It provides complete performance testing that measures end user’s experience under traffic load. The WX150 test set is a compact and lightweight addition to the Wi-Fi Air Expert family. It provides all the tools necessary for Wi-Fi networks discovery, survey, optimization, performance testing and troubleshooting in a compact form factor.",
    "finderfilter": "portable wi-fi wifi show",
    portable: 'YES',
    wifi: 'YES',
    show: 'YES',
  }
];

export const discontinued = [{
    title: 'ASA312',
    subtitle: '',
    link: '/products/asa312',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'With a flexible software/firmware-based architecture, the scalable ASA-312® combines in a single platform the multitude of traditional hardware-based test sets required to install, maintain, and monitor high-speed multi-protocol networks. The ASA-312® is designed to grow as your network grows, and as technologies change. ',
    imgsrc: './assets/images/Products/ASA312_01.webp',
    replaced: 'MPA® Multi-Protocol Analyzer',
    replacedlink: '/products/mpaseries',
  },
  {
    title: 'AT2500RQvPlus',
    subtitle: '',
    link: '/products/at2500rqvplus',
    replaced: 'AT2500-3G',
    replacedlink: '/products/at2500-3g',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'The AT2500RQvPlus is the industry\'s most complete spectrum analyzer, combining superior QAM analysis and best-in-class analog measurement capability. The enhanced AT-Web automates both the analog and digital proof-of-performance tests, saving time, making tests consistent, and providing excellent documentation. ',
    imgsrc: './assets/images/Products/AT2500RQvPlus_01.webp'
  },
  {
    title: 'BX100A+',
    subtitle: '',
    link: '/products/bx100a-plus',
    replaced: 'MTTplus-523',
    replacedlink: '/products/mttplus-523-g-fast-dsl-module',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'Comprehensive ADSL2+, ADSL2, ADSL link turn-up capabilities including ATM and IP test features all supported in a single compact handheld unit. Triple Play service verification of VoIP, IPTV, and high speed Internet is made possible using powerful IP and Web test features including Web Browser.',
    imgsrc: './assets/images/Products/480-BX100A-plus_01.webp'
  },
  {
    title: 'CM3000/CM3800',
    subtitle: '',
    link: '/products/cm3800',
    eol: '1',
    replaced: 'CX380C',
    replacedlink: '/products/cx380c',
    keyword: 'showall discontinued',
    text1: 'The CM3000 and CM3800 analyze Upstream and Downstream network performance for business and bundled services. Both instruments validate the effectiveness of DOCSIS 3.0 services. ',
    imgsrc: './assets/images/Products/480-CM3800_01.webp'
  },
  {
    title: 'CX110+',
    subtitle: '',
    link: '/products/cx110-plus',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'A next generation CATV installer meter to characterize and measure Analog and Digital video signals. For Analog carriers, Peak Video level, single or dual channel Audio levels and Carrier to Noise (C/N) measurements are possible on NTSC, PAL, or SECAM video formats. Digital QAM16/64/256 carriers with or without deep Interleaving are measured accurately with MER, BER and Constellation diagram results being reported.',
    imgsrc: './assets/images/Products/CX110-plus_01.webp',
    replaced: 'CX310',
    replacedlink: '/products/docsis-31-installation-tool-cx310',
  },
  {
    title: 'CX150-D3+',
    subtitle: '',
    link: '/products/cx150d3-plus',
    replaced: 'CX310',
    replacedlink: '/products/docsis-31-installation-tool-cx310',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'With an embedded DOCSIS 3.0 cable modem, the CX150-D3+ supports full upstream and downstream 8x4 channel bonding, IPv6 addressing and Advanced Encryption Standard (AES) encryption used in next generation DOCSIS 3.0 networks. ',
    imgsrc: './assets/images/Products/CX150D3-plus_01.webp'
  },
  {
    title: 'CX180-D3+',
    subtitle: '',
    link: '/products/cx180d3-plus',
    replaced: 'CX350s-D3.1',
    replacedlink: '/products/cx350sd31',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'An all-in-one, super-tech installation and maintenance tool for next generation CATV networks. The CX180-D3+ can be used at the headend for return path ingress scan and return path QAM analysis. Enhanced ingress monitoring in both the forward and reverse paths is possible across a 50dB dynamic range. Adjustable resolution bandwidths, measurement dwell times and attenuation provide spectrum analysis capabilities all optimized for CATV signal types and bandwidth. ',
    imgsrc: './assets/images/Products/CX180D3-plus_01.webp'
  },
  {
    title: 'CX20',
    subtitle: '',
    link: '/products/cx20',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'The CX20 Leakage Detector is an affordable accessory and leakage solution for field technicians already equipped with a CX series CATV tester. The unit features a calibrated antenna and sensitive leakage receiver with sophisticated signal processing to discriminate between leaks and noise.',
    imgsrc: './assets/images/Products/CX20_01.webp'
  },
  {
    title: 'CX350',
    subtitle: '',
    link: '/products/cx350',
    replaced: 'CX350s-D3.1',
    replacedlink: '/products/cx350sd31',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'Industry\'s first integrated test solution supporting legacy analog CATV signals, high definition DVB-C carriers and DOCSIS 3.0 cable modem emulation/measurement in a single instrument. Standard features include a high performance dual band Signal Level Meter (SLM), forward/return path ingress measurement, deep interleaving support, and QAM constellation diagram and diagnostics. ',
    imgsrc: './assets/images/Products/CX350_01.webp'
  },
  {
    title: 'CX350s',
    subtitle: '',
    link: '/products/cx350s',
    replaced: 'CX350s-D3.1',
    replacedlink: '/products/cx350sd31',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'Industry\'s first integrated test solution supporting legacy analog CATV signals, high definition DVB-C carriers and DOCSIS 3.0 cable modem emulation/measurement in a single instrument. Standard features include a high performance dual band Signal Level Meter (SLM), forward/return path ingress measurement, deep interleaving support, and QAM constellation diagram and diagnostics.',
    imgsrc: './assets/images/Products/CX350s_01.webp'
  },
  {
    title: 'CX380/CX380-D3',
    subtitle: '',
    link: '/products/cx380',
    replaced: 'CX380s-D3',
    replacedlink: '/products/cx380sd3',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'The CX380 and CX380-D3 are super-tech installation and maintenance tools for next generation CATV networks. Equipped with a large 7" touch-screen color LCD and intuitive graphical user interface, the CX380 and CX380-D3 can be used under all light conditions. These highly flexible units combine a 1GHz spectrum analyzer with 60dB dynamic range, a forward and return path Digital QAM analyzer, and an MPEG analyzer in a single portable instrument. ',
    imgsrc: './assets/images/Products/CX380_01.webp'
  },
  {
    title: 'CX380s-D3',
    subtitle: '',
    link: '/products/cx380sd3',
    replaced: 'CX380s-D3.1',
    replacedlink: '/products/cx380sd31',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'The CX380s-D3 is a super-tech installation and maintenance tool for next generation CATV networks. Equipped with a large 7" touch-screen color LCD and intuitive graphical user interface, the CX380s-D3 can be used under all light conditions. This highly flexible unit combines a 1GHz spectrum analyzer with 60dB dynamic range, a forward and return path Digital QAM analyzer, and an MPEG analyzer in a single portable instrument. ',
    imgsrc: './assets/images/Products/CX380SD3_01.webp'
  },
  {
    title: 'DI-1000MPO',
    subtitle: 'CARDSUBTITLES.FIBINSMTPMPO',
    link: '/products/digital-fiber-microscope-for-multi-fiber-connector-inspection-di-1000mpo',
    imgsrc: './assets/images/Products/Digital-Fiber-Microscope-for-Multi-Fiber-Connector-Inspection-DI-1000MPO_01.webp',
    replaced: 'DI-1000MPO+',
    replacedlink: '/products/di1000mpo-plus',
    tag: '',
    text1: 'PRODUCTS.DI1000MPO.MAINTEXT',
    portable: 'YES',
    fiber: 'YES',
    eol: '1',
    keyword: 'showall discontinued inspection Data Centers fiber scope, fiberscope, wired fiberscope, optical connector inspection, end face inspection, IEC 61300-3-35, transceiver inspection, terminal inspection MPO inspection, MPT inspection, MPO/MTP inspection'
  },
  {
    title: 'Fiberizer® Scope',
    subtitle: 'Software',
    link: '/products/fiberizer-scope',
    imgsrc: './assets/images/Products/FiberizerScope_InspectEndFace.webp',
    // replaced: 'DI-1000MPO+',
    // replacedlink: '/products/di1000mpo-plus',
    tag: '',
    text1: 'FIBERIZER.SCOPE.MAINTEXT',
    portable: 'YES',
    fiber: 'YES',
    eol: '1',
    keyword: 'showall discontinued inspection Data Centers fiber scope, fiberscope, wired fiberscope, optical connector inspection, end face inspection, IEC 61300-3-35, transceiver inspection, terminal inspection MPO inspection, MPT inspection, MPO/MTP inspection'
  },
  {
    title: 'FX10',
    subtitle: '',
    link: '/products/fx10',
    replaced: 'FX10+',
    replacedlink: '/products/fx10plus',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'Pen Style Visual Fault Locator',
    imgsrc: './assets/images/Products/FX10_01.webp'
  },
  // {
  //     title: 'FX100',
  //     subtitle: '',
  //     link: '/products/olts-automated-bi-directional-insertion-loss-and-optical-return-loss-fx100',
  //     // replaced: 'FX80',
  //     // replacedlink: '/products/fx80',
  //     eol: '1',
  //     keyword: 'showall discontinued',
  //     text1: 'Fully Automated Optical Loss Test Set (OLTS)',
  //     imgsrc: './assets/images/Products/OLTS-Automated-Bi-Directional-Insertion-Loss-and-Optical-Return-Loss-FX100_02.webp'
  // },
  {
    title: 'FX150',
    subtitle: '',
    link: '/products/fx150',
    replaced: 'FX150+',
    replacedlink: '/products/fx150-plus',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'The FX150 mini OTDR is designed for the installation, maintenance and troubleshooting of FTTx, Mobile FrontHaul/BackHaul and Metro fiber networks. The compact, lightweight platform incorporates power meter, light source, fiber inspection probe and VFL test options which add exceptional versatility to the unit. ',
    imgsrc: './assets/images/Products/FX150_01.webp'
  },
  {
    title: 'FX180',
    subtitle: 'CARDSUBTITLES.CDWDMOSA',
    link: '/products/fx180',
    replaced: 'RXT-4500/4510 Series',
    replacedlink: '/products/rxt4500module',
    imgsrc: './assets/images/Products/FX180_01.webp',
    tag: '',
    text1: 'PRODUCTS.FX180.MAINTEXT',
    portable: 'YES',
    fiber: 'YES',
    show: 'YES',
    eol: '1',
    keyword: 'showall discontinued OSA, Optical Spectrum Analyzer, WDM, CWDM, DWDM, 10G, 40G, fiber optic, singlemode'
  },
  {
    "title": "FX180X DWDM",
    "subtitle": "DWDM OCC",
    "link": "/products/optical-channel-checker-fx180x-dwdm",
    replaced: 'FX92',
    replacedlink: '/products/fx92',
    "imgsrc": "./assets/images/Products/FX180X-OCC_01.webp",
    "tag": "",
    "text1": "PRODUCTS.FX180XDWDM.MAINTEXT",
    "eol": "1",
    "keyword": "showall current Optical Channel Checker, WDM, DWDM, fiber optic, singlemode fiber optics, OCC, wavelength, frequency, power measurement",
    "Meta Description": "Compact Channel Checker Verifying DWDM Channels and Power. Simultaneously test all 18 CWDM channels or 97 DWDM channels C14-62 in a single test. This compact, robust tester measures individual channel peak wavelength/frequency and total, composite power. An optional fiberscope is also available to inspect connectors.",
    "UL Logo removed?": "yes",
    "finderfilter": "portable fiber show"
  },
  {
    title: 'FX20/FX20c',
    subtitle: '',
    link: '/products/fx20',
    replaced: 'FX40 Series',
    replacedlink: '/products/fx40series',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'Optical Power Meter',
    imgsrc: './assets/images/Products/FX20_01.webp'
  },
  {
    title: 'FX30',
    subtitle: '',
    link: '/products/fx30',
    replaced: 'FX45 Series',
    replacedlink: '/products/fx45series',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'Optical Light Source',
    imgsrc: './assets/images/Products/FX30_01.webp'
  },
  {
    title: 'FX50',
    subtitle: '',
    link: '/products/fx50',
    replaced: 'FX45 Series',
    replacedlink: '/products/fx45series',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'Premium, multi-function tester to measure Power, bi-directional Loss and Optical Return Loss (ORL) on fiber optic systems. This compact, handheld and robust device is ideallysuited for a variety of test applications for todays’ Telco, FTTx and PON access networks. ',
    imgsrc: './assets/images/Products/FX50_01.webp'
  },
  {
    title: 'FX80',
    subtitle: 'CARDSUBTITLES.PONOPM',
    link: '/products/fx80',
    replaced: 'FX81/FX81T',
    replacedlink: '/products/fx81',
    imgsrc: './assets/images/Products/FX80_01.webp',
    tag: '',
    text1: 'PRODUCTS.FX80.MAINTEXT',
    portable: 'YES',
    fiber: 'YES',
    show: 'YES',
    eol: '1',
    keyword: 'showall discontinued PON power meter fiber optic 1G singlemode FTTH discontinued'
  },
  {
    title: 'FX300 OTDR',
    subtitle: '',
    link: '/products/fx300',
    imgsrc: './assets/images/Products/FX300_01.webp',
    tag: '',
    text1: 'The VePAL FX300 is a full featured Optical test solution for technicians installing, testing, troubleshooting and restoring FTTx/PON, mobile backhaul, and related converged fiber network infrastructures.',
    portable: 'YES',
    fiber: 'YES',
    show: 'YES',
    eol: '1',
    keyword: 'showall discontinued',
    replaced: 'MTTplus-410+',
    replacedlink: '/products/mttplus-410-plus-fiber-optics-test-module',
  },
  {
    title: 'LX100+',
    subtitle: '',
    link: '/products/lx100-plus',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'A compact, handheld field test solution for next generation networks supporting Triple Play services. Equipped with an Ethernet interface, advanced IP connection tests including Ping, trace route, ARP Wiz, Web test, Web browser, and FTP upload/download can be performed to verify high speed Internet access at customer premise equipment such as Set Top Boxes (STB), and xDSL modems.',
    imgsrc: './assets/images/Products/LX100-plus_01.webp'
  },
  {
    title: 'MC100/MC1000',
    subtitle: '',
    link: '/products/mc100',
    imgsrc: './assets/images/Products/MC100_01.webp',
    tag: '',
    text1: 'The MC100 and MC1000 are highly compact media converter accessories for use with the MX/TX Ethernet product series or for standalone applications.',
    portable: 'YES',
    ethernet: 'YES',
    eol: '1',
    keyword: 'showall discontinued'
  },
  {
    "title": "MLX100",
    "subtitle": "CARDSUBTITLES.ETHLOOPBACK",
    "link": "/products/mlx100",
    "imgsrc": "./assets/images/Products/MLX100_01.webp",
    "tag": "",
    "text1": "PRODUCTS.MLX100.MAINTEXT",
    "eol": "1",
    "keyword": "showall current ethernet loopback",
    "Meta Description": "VeEX MLX100 Metro Loopback Expert is an intelligent Ethernet loopback device developed as a perfect companion to the MX100+, MX120+, MX300, and TX300 products. Loopback control can be performed in-band or via the built-in 10/100Base-T Ethernet port via an Internet connection. When paired with the compatible MX/TX series, the MLX100 is the industry’s most costeffective solution for point-to-point Service Level Agreement (SLA) verification and end-to-end performance testing.",
    "undefined": "change PDF title",
    "finderfilter": "portable ethernet show",
    replaced: 'MTX150x',
    replacedlink: '/products/mtx150x',
  },
  {
    title: 'MLX300',
    subtitle: '',
    link: '/products/mlx300',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'VeEX™ MLX300 Metro Loopback Expert is an intelligent 10GE loopback device developed as a perfect companion to VeEX 10GE testers. Loopback control can be performed in-band over the fiber interface or via the built-in 10/100Base-T Ethernet port via an Internet connection. ',
    imgsrc: './assets/images/Products/MLX300_01.webp',
    replaced: 'MTX150x',
    replacedlink: '/products/mtx150x',
  },
  {
    title: 'MTT ACM II',
    subtitle: '',
    link: '/products/mttacmii',
    replaced: 'MTTplus-522',
    replacedlink: '/products/mttplus-522-osp-plus-module',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'The Advanced Cable Maintenance chassis is a comprehensive handheld test set for qualifying the copper pair for different DSL services including VDSL2, ADSL2+ and SHDSL. ',
    imgsrc: './assets/images/Products/MTTACMII_01.webp'
  },
  {
    title: 'MTT C',
    subtitle: '',
    link: '/products/mttc',
    replaced: 'MTTplus',
    replacedlink: '/products/mttplusseries',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'The MTT® C is the ideal chassis for those who need service verification testing without the cable maintenance features. It is equipped with the same color screen as the MTT ACM II and supports many MTT modules. ',
    imgsrc: './assets/images/Products/MTTC_01.webp'
  },
  {
    title: 'MTTplus-410',
    subtitle: '',
    link: '/products/mttplusfiberopticstestmoduleoption',
    replaced: 'MTTplus-410+',
    replacedlink: '/products/mttplus-410-plus-fiber-optics-test-module',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'The Fiber Optics test module for the VeEX® MTTplus adds a full range of Optical test features that support OTDR, OPM, Light Source and VFL. ',
    imgsrc: './assets/images/Products/MTTplusFiberOpticsTestModuleOption_01.webp'
  },
  {
    "title": "MTTplus-420",
    "subtitle": "CARDSUBTITLES.GPONTESTMOD",
    "link": "/products/mttplusgpontestmoduleoption",
    replaced: 'FX120 Series',
    replacedlink: '/products/fx120',
    "imgsrc": "./assets/images/Products/MTTplusGPONTestModuleOption_01.webp",
    "tag": "",
    "text1": "PRODUCTS.MTTPLUS420.MAINTEXT",
    "eol": "1",
    "keyword": "showall discontinued GPON Analyzer, GPON,  fiber optic, singlemode mtt-plus mtt plus mtt-420 fiber optics, OLT, ONT/ONU, PLOAM, OMCI Capture/Decode, TOL, ODN",
    "Meta Description": "The new MTTplus-420 PON Analyzer test module for the VeEX® MTTplus platform is designed for GPON service activation at the ONT location. The unit checks optical power levels, and non-intrusively decodes the PLOAM and OMCI messages exchanged between the OLT and ONT allowing technicians to perform advanced troubleshooting.  In addition, Protocol errors, alarms and frame errors are reported.",
    "finderfilter": "portable fiber show"
  },
  {
    title: 'MTTplus-520',
    subtitle: '',
    link: '/products/mttplusanydsltestmoduleoption',
    replaced: 'MTTplus-523',
    replacedlink: '/products/mttplus-523-g-fast-dsl-module',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'The MTTplus-520 AnyDSL module addresses key test requirements for IP based services deployed over a ‘universal’ DSL Access network. ',
    imgsrc: './assets/images/Products/MTTplusAnyDSLTestModuleOption_01.webp'
  },
  {
    title: 'MTTplus-900',
    subtitle: 'CARDSUBTITLES.WIFIAIREXPERTTESTMOD',
    link: '/products/mttpluswifiairexperttestmoduleoption',
    replaced: 'WX150 Wi-Fi',
    replacedlink: '/products/wx150-wifi',
    imgsrc: './assets/images/Products/MTTplusWiFiAirExpertTestModuleOption_01.webp',
    tag: '',
    text1: 'PRODUCTS.MTTPLUS900.MAINTEXT',
    portable: 'YES',
    modular: 'YES',
    wifi: 'YES',
    show: 'YES',
    eol: '1',
    keyword: 'showall discontinued mtt-plus mtt plus mtt-900'
  },
  {
    title: 'MX100+',
    subtitle: '',
    link: '/products/mx100-plus',
    replaced: 'MTX150x',
    replacedlink: '/products/mtx150x',
    eol: '1',
    keyword: 'showall discontinued',
    text1: '10/100/1000Base-T and 1000Base-X interface testing supported in one compact, handheld, lightweight unit. An MSA compliant SFP interface supports field inter-changeable SFP transceivers operating at traditional telecom, but also CWDM and DWDM wavelengths.',
    imgsrc: './assets/images/Products/MX100-plus_01.webp'
  },
  {
    title: 'MX100e+',
    subtitle: '',
    link: '/products/mx100e-plus',
    imgsrc: './assets/images/Products/MX100e-plus_01.webp',
    replaced: 'MTX150x',
    replacedlink: '/products/mtx150x',
    tag: '',
    text1: 'The VeEX MX100e+ is a full-featured lightweight Ethernet test solution for 10/100/1000Base-T, 100Base-FX and 1000Base-X networks.',
    portable: 'YES',
    ethernet: 'YES',
    show: 'YES',
    eol: '1',
    keyword: 'showall discontinued'
  },
  {
    title: 'MX120+',
    subtitle: '',
    link: '/products/mx120-plus',
    replaced: 'MTX150x',
    replacedlink: '/products/mtx150x',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'Fitted with two 10/100/1000Base-T and two 1000Base-X ports, the MX120+ literally doubles and duplicates the test capabilities and features available on the MX100+; however, it also offers several unique capabilities at the same time. ',
    imgsrc: './assets/images/Products/MX120-plus_01.webp'
  },
  {
    title: 'MX120e+',
    subtitle: '',
    link: '/products/mx120e-plus',
    imgsrc: './assets/images/Products/MX120e-plus_01.webp',
    replaced: 'MTX150x',
    replacedlink: '/products/mtx150x',
    tag: '',
    text1: 'Fitted with two 10/100/1000Base-T and two 100Base-FX/1000Base-X ports, the MX120e+ doubles the test capabilities and features available on the MX100e+. Additional features include full Ethernet testing and bi-directional in-service passthrough monitoring capabilities.',
    portable: 'YES',
    ethernet: 'YES',
    show: 'YES',
    eol: '1',
    keyword: 'showall discontinued'
  },
  {
    title: 'MX300',
    subtitle: '',
    link: '/products/mx300',
    replaced: 'TX340s',
    replacedlink: '/products/tx340sadvancedmultiserviceoption',
    eol: '1',
    keyword: 'showall discontinued',
    text1: '10GE including optional dual 1GE and 10/100/1000BaseT test ports are housed in the industry’s smallest Metro/Ethernet tester. A high capacity battery pack supports up to three hours of continuous operation at 10GE test interface. ',
    imgsrc: './assets/images/Products/MX300_01.webp'
  },
  {
    title: 'NET-BOX™',
    subtitle: 'CARDSUBTITLES.INTERNETQOSQOETEST',
    link: '/products/ethernet-speed-test-solution-net-box',
    replaced: 'MTX150x Lite',
    replacedlink: '/products/mtx150x-lite',
    imgsrc: './assets/images/Products/Ethernet-Speed-Test-Solution-Net-Box_01.webp',
    tag: '',
    text1: 'PRODUCTS.NETBOX.MAINTEXT',
    portable: 'YES',
    ethernet: 'YES',
    show: 'YES',
    eol: '1',
    keyword: 'showall discontinued netbox'
  },
  {
    title: 'NIC Network Information Computer',
    subtitle: '',
    link: '/products/networkinformationcomputer',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'The Digital Lightwave®* (DLI) NIC® is a scalable test solution for verifying and qualifying the performance of today’s multi-protocol global communications networks, covering Ethernet, Fibre Channel, OTN, SONET/SDH, and PDH/DSn testing. ',
    imgsrc: './assets/images/Products/NetworkInformationComputer_01.webp',
    replaced: 'MPA® Multi-Protocol Analyzer',
    replacedlink: '/products/mpaseries',
  },
  {
    title: 'OPX-BOX+',
    subtitle: '',
    link: '/products/opxbox-plus',
    replaced: 'OPX-BOXe',
    replacedlink: '/products/opxboxe',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'The OPX-BOX+ is an ultra-compact, OTDR designed to operate remotely using Fiberizer software. The unit can be controlled via USB or Bluetooth from Windows, MacOS, Linux or Android devices. ',
    imgsrc: './assets/images/Products/OPXBOX-plus_01.webp'
  },
  {
    "title": "OX4000",
    "subtitle": "CARDSUBTITLES.FIBOPTSWITCH",
    "link": "/products/ox4000",
    "imgsrc": "./assets/images/Products/OX4000_01.webp",
    "tag": "VeSion",
    replaced: 'OXC-4000',
    replacedlink: '/products/oxc4000',
    "text1": "PRODUCTS.OX4000.MAINTEXT",
    "eol": "1",
    "keyword": "showall discontinued switch, fiber, singlemode, RFTS, Remote Fiber Monitoring fiber optics",
    "Meta Description": "Part of the VeSion® system, the OX4000 series optical switches provide reliable, fast, and repeatable performance. Units can be controlled via built-in keypad or remotely via RS232 or Ethernet Remote Fiber Test Systems (RFTS). The OX-4000 in tandem with the OXA-4000 to increase available monitoring ports when more than 128 ports required.",
    "UL Logo removed?": "yes",
    "finderfilter": "rackmount fiber show"
  },
  {
    title: 'OX-MPO-12',
    subtitle: 'CARDSUBTITLES.MINIFIBOPTSWITCH',
    link: '/products/optical-switch-ox-mpo-12',
    imgsrc: './assets/images/Products/Optical-Switch-OX-MPO-12_01.webp',
    tag: '',
    text1: 'PRODUCTS.OXMPO12.MAINTEXT',
    fiber: 'YES',
    portable: 'YES',
    show: 'YES',
    eol: '1',
    keyword: 'showall discontinued switch fiber MPO singlemode Data Centers construction'
  },
  {
    title: 'RealWORX®',
    subtitle: 'Web Performance Verification System',
    link: '/products/realworx',
    imgsrc: './assets/images/Products/RealWORX_01.webp',
    tag: '',
    replaced: 'VeSion CX280X',
    replacedlink: '/products/cx280x',
    text1: 'The RealWORX Web Performance Verification System allows operators to monitor return ingress levels, analog signal performance, as well as QAM performance and statistics from many nodes using any browser interface. RealWORX compares RF performance against user-set limits and generates an alarm when signal impairments are detected. The system sends alarm notifications by email, pager, or cell-phone, and can report to the NOC via an SNMP trap interface to ensure that the operator is notified promptly when an alarm occurs. ',
    eol: '1',
    keyword: 'showall discontinued'
  },
  {
    "title": "RTU-300 Family",
    "subtitle": "CARDSUBTITLES.RACKMOUNTTEST",
    "link": "/products/rtu-300",
    "imgsrc": "./assets/images/Products/RTU-300_01.webp",
    "tag": "",
    replaced: 'RTU-300+',
    replacedlink: '/products/rtu-300plus',
    "text1": "PRODUCTS.RTU300.MAINTEXT",
    "eol": "1",
    "keyword": "showall discontinued modular platform chassis instrument meter test set testset tester head centralized remote multi-user access",
    "Meta Description": "The RTU-300 platform is a rack-mounted centralized test solution specially designed for service turn-up and maintenance test applications. The RTU-300 can be remotely accessed via a web browser or VNC when configured for standalone operation, or it can be operated and integrated into the VeSion® cloud-based system. Features include 1G to 100G Ethernet test applications, including high performance stateful TCP suites, like RFC6349, required for repeatable and reliable testing of broadband or IP access services. When the RTU-300 platform is configured for standalone operation additional features are supported like OTN, SDH/SONET, Fibre Channel, and CPRI.",
    "undefined": "missing spec",
    "finderfilter": "ethernet modular rackmount show"
  },
  {
    "title": "RTU-320",
    "subtitle": "CARDSUBTITLES.DUAL10GTEST",
    "link": "/products/rtu-320",
    "imgsrc": "./assets/images/Products/RTU-320_01.webp",
    "tag": "",
    replaced: 'RTU-340',
    replacedlink: '/products/rtu-340',
    "text1": "PRODUCTS.RTU320.MAINTEXT",
    "eol": "1",
    "keyword": "showall discontinued ethernet internet QoS QoE SLA BER BERT throughput RFC 2544 RFC6349 V-PERF iperf v-perf speed speedtest 10G 1G sdh sonet PDH DSn T1 T3 OC STS E1 fibre channel datacom ieee C37.94 CPRI OBSAI SyncE Sync jitter wander",
    "Meta Description": "The RTU-320 hardware option for the RTU-300 standalone platform offers a full-featured centralized test solution for Ethernet, OTN, SONET/SDH, PDH/DSn, Fibre Channel and CPRI/OBSAI. This factory-installed hardware option allows flexibility to fit any application, such as the addition of a second RTU-320 or 100G (RTU-600) to be installed concurrently in the same test platform.",
    "UL Logo removed?": "yes",
    "finderfilter": "ethernet modular show"
  },
  {
    "title": "RTU-320/600x VeSion",
    "subtitle": "CARDSUBTITLES.REMOTETESTUNIT",
    "link": "/products/remote-test-unit-ethernet-ip-test-module-rtu-300-320",
    "imgsrc": "./assets/images/Products/Remote-Test-Unit-Ethernet-IP-Test-Module-RTU-300-320_01.webp",
    "tag": "VeSion",
    "text1": "PRODUCTS.RTU320600X.MAINTEXT",
    "eol": "1",
    "keyword": "showall discontinued ethernet cloud rtu-320 rtu-600x rtu 320 600x ethernet internet QoS QoE SLA BER BERT throughput RFC 2544 6349 iperf v-perf speed speedtest 10G 1G SyncE cloud vesion vision",
    "Meta Description": "Part of the VeSion® cloud-based system, the RTU-300 platform with the RTU-320 and RTU-600x module tests Ethernet/IP network performance. Features include dual plug-in module support with up to four dedicated test ports for optimized testing.\r\n\r\n",
    "UL Logo removed?": "yes",
    "finderfilter": "ethernet modular show"
  },
  {
    title: 'RTU-300/410',
    subtitle: '',
    link: '/products/remote-test-unit-optical-fiber-networks-rtu-300-410',
    replaced: 'RTU-4000/RTU-4100',
    replacedlink: '/products/remote-fiber-test-system-rfts-rtu-4000-4100',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'VeEX® RTU is a Remote Test Unit for Testing and Preventive Monitoring of fiber and multi-service transport infrastructures, reducing Mean Time To Repair (MTTR). ',
    imgsrc: './assets/images/Products/480-Remote-Test-Unit-Optical-Fiber-Networks-RTU-300-410_01.webp'
  },
  {
    title: 'RXT-2600',
    subtitle: '',
    link: '/products/rxt2600module',
    eol: '1',
    keyword: 'showall discontinued RXT, RXT1200, RXT-1200, RXT 1200, 1200',
    text1: 'The RXT-2600 SHDSL.bis module for the RXT Platform addresses key test requirements for business class services and mobile backhaul deployed over an SHDSL access network. The RXT-2600 supports both standard ITU-T G.991.2 and enhanced SHDSL.bis data rates for one to four copper pairs. ',
    imgsrc: './assets/images/Products/RXT2600Module_01.webp'
  },
  {
    title: 'RXT-3900',
    subtitle: '',
    link: '/products/rxt3900module',
    replaced: 'RXT-6200',
    replacedlink: '/products/rxt6200module',
    eol: '1',
    keyword: 'showall discontinued RXT, RXT1200, RXT-1200, RXT 1200, 1200',
    text1: 'The RXT-3900 offers full-featured portable test solutions for Transport and Access technologies, such as 16G Fibre Channel, Carrier Ethernet, OTN, SONET/SDH and CPRI/OBSAI. This field-replaceable module allows flexibility to fit any application, for example, high-speed storage area networks. ',
    imgsrc: './assets/images/Products/RXT3900Module_01.webp'
  },
  {
    title: 'RXT-4111',
    subtitle: '',
    link: '/products/rxt4111module',
    imgsrc: './assets/images/Products/RXT4111Module_01.webp',
    tag: '',
    text1: 'The RXT-4111 test module for the VeEX® RXT-1200 platform features a tunable DWDM OTDR for testing optical Mux/Demux to verify channel routing and end to end connectivity. Multi-service DWDM networks can be verified with a single test platform ensuring maximum test productivity. Fiberizer® software for Windows® Desktop, Android™, and/or Apple® mobile devices is available to assist in data transfer, record management, and report generation for various VeEX fiber optics testers. View the Fiberizer webpage for more details.',
    portable: 'YES',
    modular: 'YES',
    fiber: 'YES',
    show: 'YES',
    eol: '1',
    keyword: 'showall discontinued RXT, RXT1200, RXT-1200, RXT 1200, 1200',
    replaced: 'RXT-4113+',
    replacedlink: '/products/rxt4113plusmodule',
  },
  {
    title: 'RXT-4112',
    subtitle: '',
    link: '/products/rxt4112module',
    imgsrc: './assets/images/Products/RXT4112Module_01.webp',
    tag: '',
    text1: 'The RXT-4112 test module for the VeEX® RXT-1200 platform features a range of Optical test functions including CWDM OTDR, OPM, Light Source and VFL. Multi-protocol networks utilizing CWDM technology can easily be verified with a single test platform ensuring maximum test productivity. Fiberizer® software for Windows® Desktop, Android™, and/or Apple® mobile devices is available to assist in data transfer, record management, and report generation for various VeEX fiber optics testers. View the Fiberizer webpage for more details.',
    portable: 'YES',
    modular: 'YES',
    fiber: 'YES',
    show: 'YES',
    eol: '1',
    keyword: 'showall discontinued RXT, RXT1200, RXT-1200, RXT 1200, 1200',
    replaced: 'RXT-4113+',
    replacedlink: '/products/rxt4113plusmodule',
  },
  {
    title: 'RXT-4113',
    subtitle: '',
    link: '/products/rxt4113module',
    imgsrc: './assets/images/Products/RXT4113Module_01.webp',
    replaced: 'RXT-4113+',
    replacedlink: '/products/rxt4113plusmodule',
    tag: '',
    text1: 'The RXT-4113 is the industry’s first combined CWDM/DWDM OTDR in a single test module. CWDM and DWDM (C-band) wavelength tuning with up to 500,000 data point sampling resolution offers unprecedented network characterization. Attenuation profiling and end-to-end connectivity using the single test port ensures maximum productivity.',
    portable: 'YES',
    modular: 'YES',
    fiber: 'YES',
    show: 'YES',
    eol: '1',
    keyword: 'showall discontinued RXT, RXT1200, RXT-1200, RXT 1200, 1200',
  },
  {
    title: 'SunLite OTDR',
    subtitle: '',
    link: '/products/sunliteotdr',
    replaced: 'FX150+',
    replacedlink: '/products/fx150-plus',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'The SunLite® OTDR is a lightweight, handheld mini OTDR optimized for the installation and troubleshooting of FTTx, PON, CATV, Mobile Backhaul, and Metro fiber networks. ',
    imgsrc: './assets/images/Products/SunLiteOTDR_01.webp'
  },
  {
    title: 'SunLite OTDR+',
    subtitle: '',
    link: '/products/sunliteotdr-plus',
    replaced: 'FX150+',
    replacedlink: '/products/fx150-plus',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'SunLite® OTDR+ is a lightweight, handheld mini OTDR optimized for the installation and troubleshooting of FTTx, PON, CATV, Mobile Backhaul, and Metro fiber networks. Power meter, light source, fiber inspection probe and VFL test options add versatility to the unit. ',
    imgsrc: './assets/images/Products/SunLiteOTDR-plus_01.webp'
  },
  {
    title: 'TX130/E+',
    subtitle: '',
    link: '/products/tx130e-plus',
    imgsrc: './assets/images/Products/TX130E-plus_01.webp',
    replaced: 'MTX150',
    replacedlink: '/products/mtx150',
    tag: '',
    text1: 'The TX130/E+ platform offers customers a single, multifunctional access network diagnostic tool.',
    portable: 'YES',
    transport: 'YES',
    show: 'YES',
    eol: '1',
    keyword: 'showall discontinued'
  },
  {
    title: 'TX300/E',
    subtitle: '',
    link: '/products/tx300e',
    replaced: 'TX340s',
    replacedlink: '/products/tx340sadvancedmultiserviceoption',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'Weighing less than 2.5kg (6lbs), the TX300/E is the smallest full featured 10 Gigabit Next Generation Network analyzer available. Versatile hardware and software options optimize configuration for transport applications at rates ranging from DS1/E1 to OC-192/STM-64 and/or Metro Ethernet testing options including 10GE, 1GE and 10/100/1000Base-T. ',
    imgsrc: './assets/images/Products/TX300E_01.webp'
  },
  {
    title: 'TX300M',
    subtitle: '',
    link: '/products/tx300m',
    replaced: 'TX340s',
    replacedlink: '/products/tx340sadvancedmultiserviceoption',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'The TX300M is a full featured portable test solution for OTN, SDH, SONET, PDH, DSn networks, and offers extensive support for Mobile Backhaul technologies with SyncE, 1588v2 PTP, Carrier Ethernet and CPRI testing. Versatile hardware and software options optimize configuration for transport applications at rates ranging from DS1/E1 to OC-192/STM-64 and/or Metro Ethernet testing options including 10GE, 1GE and 10/100/1000Base-T. ',
    imgsrc: './assets/images/Products/TX300M_01.webp'
  },
  {
    title: 'UPM 100',
    subtitle: '',
    link: '/products/upm100',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'The UPM 100 USB Power Meter is used with VeEX software to capture dB loss readings in optical fiber systems. ',
    imgsrc: './assets/images/Products/UPM100_01.webp',
    replaced: 'FX40 Series',
    replacedlink: '/products/fx40series',
  },
  {
    title: 'VIS 400D',
    subtitle: '',
    link: '/products/vis400d',
    replaced: 'DI-1000',
    replacedlink: '/products/di1000',
    eol: '1',
    keyword: 'showall discontinued',
    text1: 'The VIS 400D fiber inspection scope measures the acceptability of optical connector end faces, delivering precision and convenience in one easy-to-use, cost effective package. ',
    imgsrc: './assets/images/Products/CX150D3-plus_01.webp'
  },
  {
    title: 'VS-500',
    subtitle: 'Digital Fiber Inspection Microscope',
    link: '/products/vs500',
    imgsrc: './assets/images/Products/VS500_01.webp',
    replaced: 'DI-1000',
    replacedlink: '/products/di1000',
    tag: '',
    text1: 'The affordable VS-500 digital fiber inspection microscope features a single-finger focusing knob, brightness control and a digital sensor with detectable resolution to 0.5 μm, providing excellent image viewing and analysis. A variety of tips for industry standard connector types is available.',
    portable: 'YES',
    fiber: 'YES',
    show: 'YES',
    eol: '1',
    keyword: 'showall discontinued'
  },
];